export const copy = {
  nav: {
    home: { en: "Home", th: "หน้าหลัก" },
    about: { en: "About", th: "เกี่ยวกับเรา" },
    lessons: { en: "Lessons", th: "บทเรียน" },
    resources: { en: "Resources", th: "สื่อการเรียน" },
    exerciseBank: { en: "Exercise Bank", th: "คลังแบบฝึกหัด" },
    topicLibrary: { en: "Topic Library", th: "คลังหัวข้อ" },
    contact: { en: "Contact", th: "ติดต่อเรา" },
    pricing: { en: "Pricing", th: "ราคา" },
    membership: { en: "Membership", th: "สมาชิก" },
    myPathway: { en: "My Pathway", th: "แผนการเรียนของฉัน" },
    myPathwayDropdown: { en: "My Pathway", th: "แผนการเรียนของฉัน" },
    sampleLessons: { en: "4 Sample Lessons", th: "ตัวอย่างบทเรียน 4 บท" },
    lessonLibrary: { en: "Lesson Library", th: "คลังบทเรียน" },
    freeLessons: { en: "Free Lessons", th: "บทเรียนทดลองฟรี" },
  },
  uiLabel: { en: "UI:", th: "ภาษา:" },
  lessonHeader: {
    backLink: { en: "Back to Lesson Library", th: "กลับไปหน้าคลังบทเรียน" },
    backstoryLabel: { en: "Backstory", th: "เรื่องราวเบื้องหลัง" },
    levelPrefix: { en: "Level", th: "ระดับที่" },
    lessonPrefix: { en: "Lesson", th: "บทเรียน" },
    checkpointLabel: { en: "Checkpoint", th: "จุดตรวจสอบ" },
    checkpointLabelShort: { en: "CHP", th: "จุดตรวจสอบ" },
  },
  prepareCard: {
    title: { en: "Before you Listen", th: "ก่อนฟังบทสนทนา" },
    subtitle: {
      en: "Get familiar with the words you'll hear in the conversation.",
      th: "ทำความคุ้นเคยกับคำศัพท์ที่คุณจะได้ยินในบทสนทนา",
    },
  },
  listenCta: {
    listen: { en: "LISTEN TO THE CONVERSATION", th: "ฟังบทสนทนา" },
    playing: { en: "NOW PLAYING", th: "กำลังเล่น" },
  },
  lessonSidebar: {
    lessonLabel: { en: "Lesson", th: "บทเรียน" },
    checkpoint: { en: "Checkpoint", th: "จุดตรวจสอบ" },
    labels: {
      comprehension: { en: "Comprehension", th: "ความเข้าใจ" },
      transcript: { en: "Transcript", th: "สคริปต์บท" },
      apply: { en: "Apply", th: "การนำไปใช้" },
      understand: { en: "Understand", th: "การทำความเข้าใจ" },
      extra_tip: { en: "Extra Tips", th: "เคล็ดลับเพิ่มเติม" },
      common_mistake: { en: "Common Mistakes", th: "ข้อผิดพลาดที่พบบ่อย" },
      phrases_verbs: { en: "Phrases & Verbs", th: "วลีและคำกริยา" },
      culture_note: { en: "Culture Note", th: "เกร็ดความรู้ทางวัฒนธรรม" },
      practice: { en: "Practice", th: "แบบฝึกหัด" },
    },
  },
  lessonContent: {
    checkAnswers: { en: "Check answers", th: "ตรวจสอบคำตอบ" },
    checking: { en: "Checking...", th: "กำลังตรวจ..." },
    completeBeforeCheck: {
      en: "Answer all the questions before checking your answers.",
      th: "กรุณาตอบคำถามทุกข้อก่อนตรวจคำตอบ",
    },
    applySubmit: { en: "SEE AN EXAMPLE ANSWER", th: "ดูตัวอย่างคำตอบ" },
    applyNote: { en: "Don’t worry about making mistakes!", th: "ไม่ต้องกังวลว่าจะทำผิด!" },
    applyResponseNote: {
      en: "This is just one example. Go to the Understand section to learn more!",
      th: "นี่เป็นเพียงหนึ่งตัวอย่าง ไปที่หัวข้อทำความเข้าใจเพื่อเรียนรู้เพิ่มเติม!",
    },
  },
  profileDropdown: {
    accountSettings: { en: "Account Settings", th: "ตั้งค่าบัญชีผู้ใช้" },
    logout: { en: "Log Out", th: "ออกจากระบบ" },
  },
  authButtons: {
    signUp: { en: "Sign Up", th: "สมัครสมาชิก" },
    signIn: { en: "Log In", th: "เข้าสู่ระบบ" },
    logout: { en: "Log Out", th: "ออกจากระบบ" },
  },
  authModals: {
    signIn: {
      title: { en: "Log In to Pailin Abroad", th: "เข้าสู่ระบบ Pailin Abroad" },
      emailLabel: { en: "Email Address", th: "อีเมล" },
      emailPlaceholder: { en: "Enter your email", th: "กรอกอีเมลของคุณ" },
      passwordLabel: { en: "Password", th: "รหัสผ่าน" },
      passwordPlaceholder: { en: "Enter your password", th: "กรอกรหัสผ่านของคุณ" },
      rememberMe: { en: "Remember me", th: "จดจำบัญชีฉันไว้" },
      forgotLink: { en: "Forgot password?", th: "ลืมรหัสผ่าน?" },
      submit: { en: "Log In", th: "เข้าสู่ระบบ" },
      submitting: { en: "LOGGING IN...", th: "กำลังเข้าสู่ระบบ..." },
      divider: { en: "OR", th: "หรือ" },
      google: { en: "Continue with Google", th: "เข้าสู่ระบบด้วยบัญชี Google" },
      googleConnecting: { en: "Connecting to Google...", th: "กำลังเชื่อมต่อกับ Google..." },
      noAccount: { en: "Don't have an account? ", th: "คุณยังไม่มีบัญชีใช่ไหม? " },
      signUpLink: { en: "Sign up for free", th: "สมัครฟรี" },
      errors: {
        missingFields: { en: "Please enter both email and password.", th: "กรุณากรอกอีเมลและรหัสผ่าน" },
        invalidCredentials: {
          en: "Incorrect password or email address",
          th: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
        },
        authError: {
          en: "We couldn't sign you in. Please try again.",
          th: "ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่อีกครั้ง",
        },
        network: {
          en: "Can't reach the server. Check your connection and try again.",
          th: "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ กรุณาตรวจสอบการเชื่อมต่อแล้วลองใหม่",
        },
        fallbackHelp: {
          en: "If this keeps happening, try resetting your password.",
          th: "หากยังเกิดขึ้นอยู่ ลองรีเซ็ตรหัสผ่าน",
        },
      },
    },
    signUp: {
      title: { en: "Sign Up for Pailin Abroad", th: "สมัครสมาชิก Pailin Abroad" },
      subtitle: { en: "Make an account to get access to our free content!", th: "สร้างบัญชีผู้ใช้เพื่อเข้าถึงบทเรียนฟรีของเรา!" },
      backAria: { en: "Back to sign up options", th: "กลับไปยังตัวเลือกการสมัครสมาชิก" },
      emailPlaceholder: { en: "Email Address", th: "ที่อยู่อีเมล" },
      createAccount: { en: "CREATE FREE ACCOUNT", th: "สร้างบัญชีผู้ใช้ฟรี" },
      creatingAccount: { en: "SIGNING UP...", th: "กำลังสมัครสมาชิก..." },
      google: { en: "Continue with Google", th: "ดำเนินการต่อด้วย Google" },
      googleConnecting: { en: "Connecting to Google...", th: "กำลังเชื่อมต่อกับ Google..." },
      emailContinue: { en: "Continue with email", th: "เข้าสู่ระบบด้วยบัญชีอีเมล" },
      alreadyHave: { en: "Already have an account?", th: "มีบัญชีผู้ใช้อยู่แล้วใช่ไหม?" },
      loginLink: { en: "Log in", th: "เข้าสู่ระบบ" },
      success: {
        en: "Check your email to continue. If you already have an account, the link will sign you in.",
        th: "กรุณาตรวจสอบอีเมลเพื่อดำเนินการต่อ หากคุณมีบัญชีอยู่แล้ว ลิงก์นี้จะพาคุณเข้าสู่ระบบ",
      },
      errors: {
        missingEmail: { en: "Please enter your email address.", th: "กรุณากรอกที่อยู่อีเมล" },
        invalidEmail: { en: "Please enter a valid email address.", th: "กรุณากรอกอีเมลให้ถูกต้อง" },
        signupFailed: { en: "Signup failed", th: "การสมัครสมาชิกล้มเหลว" },
        unexpected: { en: "An unexpected error occurred.", th: "เกิดข้อผิดพลาดที่ไม่คาดคิด" },
      },
      terms: {
        prefix: { en: "By signing up, you agree to the", th: "ในการสมัครสมาชิก คุณได้ยอมรับ" },
        termsLink: { en: "Terms of Service", th: "เงื่อนไขการให้บริการ" },
        and: { en: "and acknowledge that you have read our", th: "และรับทราบว่าคุณได้อ่าน" },
        privacyLink: { en: "Privacy Policy", th: "นโยบายความเป็นส่วนตัวของเรา" },
        suffix: { en: ".", th: "แล้ว" },
      },
    },
    emailConfirmation: {
      heading: { en: "You've got mail!", th: "คุณได้รับอีเมลใหม่!" },
      messagePrefix: { en: "We just sent a message to you at ", th: "เราได้ส่งอีเมลไปให้คุณที่ " },
      messageSuffix: {
        en: ". Click the link inside to continue. If this email already has an account, we'll sign you in instead of creating another one.",
        th: " แล้ว กรุณาคลิกลิงก์ในอีเมลเพื่อดำเนินการต่อ หากอีเมลนี้มีบัญชีอยู่แล้ว เราจะพาคุณเข้าสู่ระบบโดยไม่สร้างบัญชีซ้ำ",
      },
      instructions: {
        en: "If you don't receive the email within a few minutes, please check your spam or junk folder. Or, you can click the button below to resend it.",
        th: "หากคุณไม่ได้รับอีเมลภายในไม่กี่นาที กรุณาตรวจสอบโฟลเดอร์สแปมหรือจดหมายขยะภายในอีเมลของคุณ หรือคลิกปุ่มทางด้านล่างเพื่อทำการส่งอีเมลอีกครั้ง",
      },
      resend: { en: "RESEND EMAIL", th: "ส่งอีเมลอีกครั้ง" },
      sending: { en: "Sending...", th: "กำลังส่ง..." },
      noEmailError: { en: "Error: No email found", th: "ข้อผิดพลาด: ไม่พบอีเมล" },
      resendSuccess: { en: "Verification email sent! Check your inbox.", th: "ส่งอีเมลยืนยันแล้ว! กรุณาตรวจสอบกล่องจดหมายของคุณ" },
      resendFail: { en: "Failed to send email. Please try again.", th: "ส่งอีเมลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง" },
    },
    forgotPassword: {
      title: { en: "Forgot password?", th: "ลืมรหัสผ่าน?" },
      passwordlessNote: {
        en: "Go passwordless! We’ll send you an email.",
        th: "เข้าสู่ระบบแบบไม่ใช้รหัสผ่าน! เราจะส่งอีเมลให้คุณ",
      },
      emailPlaceholder: { en: "Email Address", th: "ที่อยู่อีเมล" },
      sendMagicLink: { en: "Get a sign-in link", th: "รับลิงค์เพื่อเข้าสู่ระบบ" },
      sending: { en: "SENDING...", th: "กำลังส่ง..." },
      divider: { en: "OR", th: "หรือ" },
      resetTitle: { en: "Reset password", th: "เปลี่ยนรหัสผ่านใหม่" },
      resetDescription: {
        en: "Enter your email address to reset your password",
        th: "กรอกอีเมลของคุณเพื่อเปลี่ยนรหัสผ่าน",
      },
      resetButton: { en: "RESET PASSWORD", th: "รีเซ็ตรหัสผ่าน" },
      backToLogin: { en: "Back to log in", th: "กลับไปที่หน้าเข้าสู่ระบบ" },
      errors: {
        missingEmailFirst: { en: "Please enter your email address first", th: "กรุณากรอกที่อยู่อีเมลก่อน" },
        missingEmail: { en: "Please enter your email address", th: "กรุณากรอกที่อยู่อีเมล" },
        magicFail: { en: "Failed to send magic link. Please try again.", th: "ส่งลิงก์ล้มเหลว กรุณาลองใหม่อีกครั้ง" },
        resetFail: { en: "Failed to send reset email. Please try again.", th: "ส่งอีเมลรีเซ็ตไม่สำเร็จ กรุณาลองใหม่อีกครั้ง" },
      },
      success: {
        magicSent: {
          en: "Magic link sent! Check your email and click the link to log in.",
          th: "ส่งลิงก์แล้ว! ตรวจสอบอีเมลและคลิกลิงก์เพื่อเข้าสู่ระบบ",
        },
        resetSent: {
          en: "Password reset email sent! Check your email and follow the instructions to reset your password.",
          th: "ส่งอีเมลรีเซ็ตรหัสผ่านแล้ว! กรุณาตรวจสอบอีเมลและทำตามขั้นตอนเพื่อรีเซ็ตรหัสผ่าน",
        },
      },
    },
    confirmPassword: {
      title: { en: "Confirm your current password", th: "ยืนยันรหัสผ่านปัจจุบัน" },
      label: { en: "Password", th: "รหัสผ่าน" },
      placeholder: { en: "Enter your current password", th: "กรอกรหัสผ่านปัจจุบัน" },
      confirm: { en: "CONFIRM", th: "ยืนยัน" },
      confirming: { en: "CONFIRMING...", th: "กำลังยืนยัน..." },
      errors: {
        missing: { en: "Please enter your current password.", th: "กรุณากรอกรหัสผ่านปัจจุบัน" },
        noEmail: { en: "No email found for your account. Please log in again.", th: "ไม่พบอีเมลของบัญชี กรุณาเข้าสู่ระบบใหม่" },
      },
    },
    resetSent: {
      title: { en: "Check your email", th: "ตรวจสอบอีเมลของคุณ" },
      defaultMessage: {
        en: "Password reset email sent. Please check your inbox.",
        th: "ส่งอีเมลรีเซ็ตรหัสผ่านแล้ว กรุณาตรวจสอบกล่องจดหมายของคุณ",
      },
      ok: { en: "OK", th: "ตกลง" },
    },
  },
  lessonLibraryPage: {
    title: { en: "Lesson Library", th: "คลังบทเรียน" },
    subtitle: {
      en: "Over 150 conversation-based lessons to improve your English",
      th: "บทเรียนสนทนามากกว่า 150 บทเพื่อพัฒนาภาษาอังกฤษของคุณ",
    },
  },
  topicLibraryPage: {
    title: { en: "Topic Library", th: "คลังหัวข้อ" },
    subtitle: {
      en: "Further explanations on a range of interesting ESL topics",
      th: "คำอธิบายเพิ่มเติมเกี่ยวกับห้อข้อการใช้ภาษาอังกฤษที่น่าสนใจ",
    },
    backToResources: {
      en: "← BACK TO ALL RESOURCES",
      th: "กลับไปที่หน้าสื่อการเรียนทั้งหมด",
    },
    featuredButton: { en: "Featured Topics", th: "หัวข้อแนะนำ" },
    allButton: { en: "View All Topics", th: "ดูหัวข้อทั้งหมด" },
    searchPlaceholder: { en: "Search topics", th: "ค้นหาหัวข้อ" },
    loading: { en: "Loading topics...", th: "กำลังโหลดหัวข้อ..." },
    emptyTitle: { en: "No topics available yet", th: "ยังไม่มีหัวข้อ" },
    emptyBody: {
      en: "Topics will appear here when they are added to the library.",
      th: "หัวข้อจะปรากฏที่นี่เมื่อมีการเพิ่มเข้าในคลัง",
    },
    errorTitle: { en: "Topic Library", th: "คลังหัวข้อ" },
    planNotice: {
      freeTitle: { en: "You're on our free plan.", th: "คุณกำลังใช้งานแพ็กเกจเรียนฟรี" },
      freeDesc: {
        en: "You’ve got access to our featured resources. Unlock all of our Resource pages when you become a member!",
        th: "คุณสามารถเข้าถึงสื่อการเรียนที่แนะนำของเราได้ ปลดล็อกแหล่งการเรียนรู้ของเราทั้งหมดได้เมื่อสมัครสมาชิก!",
      },
      noAccountTitle: { en: "Looks like you don't have an account.", th: "ดูเหมือนว่าคุณยังไม่มีบัญชีผู้ใช้" },
      noAccountDesc: {
        en: "Sign up for free to access our featured resources!",
        th: "สมัครสมาชิกฟรีเพื่อเข้าถึงสื่อการเรียนแนะนำของเรา",
      },
      freeCta: { en: "BECOME A MEMBER", th: "สมัครสมาชิก" },
      noAccountCta: { en: "SIGN UP FOR FREE", th: "สมัครสมาชิกฟรี" },
    },
    lockNotice: {
      link: { en: "Sign up for free", th: "สมัครสมาชิกฟรี" },
      suffix: {
        en: " to access our featured resources!",
        th: "เพื่อเข้าถึงสื่อการเรียนแนะนำของเรา",
      },
    },
    loadingImageAlt: { en: "Loading topic library", th: "กำลังโหลดคลังหัวข้อ" },
    loadingErrorTitle: { en: "Something went wrong", th: "เกิดข้อผิดพลาด" },
    loadingErrorBody: {
      en: "We couldn't load the topic library. Please try refreshing the page.",
      th: "เราไม่สามารถโหลดคลังหัวข้อได้ กรุณารีเฟรชหน้าเว็บแล้วลองอีกครั้ง",
    },
  },
  exerciseBankPage: {
    title: { en: "Exercise Bank", th: "สื่อการเรียน" },
    subtitle: {
      en: "Additional practice exercises for those difficult grammar topics.",
      th: "แบบฝึกหัดเพิ่มเติมสำหรับกฎไวยากรณ์ที่เข้าใจยาก",
    },
    featuredButton: { en: "Featured Exercises", th: "แบบฝึกหัดที่แนะนำ" },
    categoriesButton: { en: "View by Category", th: "ดูตามหมวดหมู่" },
    searchPlaceholder: { en: "Search exercises", th: "ค้นหาแบบฝึกหัด" },
    selectCategory: { en: "Select a category", th: "เลือกหมวดหมู่" },
    viewSection: { en: "View section →", th: "ดูหัวข้อนี้ →" },
    exploreSection: { en: "Go to Exercises →", th: "ไปที่แบบฝึกหัด →" },
    featuredCountLabel: { en: "Featured", th: "แบบฝึกหัดแนะนำ" },
    exerciseCount: {
      singular: { en: "exercise in this section.", th: "แบบฝึกหัดในหัวข้อนี้" },
      plural: { en: "exercises in this section.", th: "แบบฝึกหัดในหัวข้อนี้" },
    },
    loading: { en: "Loading exercise bank...", th: "กำลังโหลดคลังแบบฝึกหัด..." },
    loadingFeatured: { en: "Loading featured exercises...", th: "กำลังโหลดแบบฝึกหัดแนะนำ..." },
    loadingCategories: {
      en: "We’re loading categories for the exercise bank. Check back soon!",
      th: "กำลังโหลดหมวดหมู่สำหรับคลังแบบฝึกหัด กรุณากลับมาตรวจสอบอีกครั้ง!",
    },
    noSearchResults: {
      en: "No exercises match your search.",
      th: "ไม่พบแบบฝึกหัดที่ตรงกับการค้นหา",
    },
    noFeatured: {
      en: "No featured exercises yet. Check back soon!",
      th: "ยังไม่มีแบบฝึกหัดแนะนำ กลับมาตรวจสอบอีกครั้งเร็วๆ นี้!",
    },
    noExercises: { en: "No exercises available yet.", th: "ยังไม่มีแบบฝึกหัด" },
    noExercisesInCategory: {
      en: "No exercises available in this category yet.",
      th: "ยังไม่มีแบบฝึกหัดในหมวดหมู่นี้",
    },
    lockNotice: {
      upgrade: { en: "Upgrade to view!", th: "อัปเกรดเพื่อดู!" },
      cta: { en: "Become a member", th: "สมัครสมาชิก" },
    },
    planNotice: {
      free: {
        heading: { en: "You're on our free plan.", th: "คุณกำลังใช้งานแพ็กเกจเรียนฟรี" },
        upgradeLink: { en: "Upgrade", th: "อัปเกรด" },
        upgradeRest: {
          en: "to enjoy full access to our Exercise Bank.",
          th: "เพื่อเข้าถึงคลังแบบฝึกหัดทั้งหมดของเรา",
        },
        browse: {
          en: "You can still browse the featured exercises available on your plan.",
          th: "ยังสามารถดูแบบฝึกหัดแนะนำที่ใช้ได้กับแผนของคุณ",
        },
      },
      noAccount: {
        heading: { en: "Looks like you don't have an account.", th: "ดูเหมือนว่าคุณยังไม่มีบัญชีผู้ใช้" },
        desc: {
          en: "Sign up for free to access our featured resources!",
          th: "สมัครสมาชิกฟรีเพื่อเข้าถึงสื่อการเรียนแนะนำของเรา",
        },
        cta: { en: "SIGN UP FOR FREE", th: "สมัครสมาชิกฟรี" },
      },
    },
    loadingImageAlt: { en: "Loading exercise bank", th: "กำลังโหลดคลังแบบฝึกหัด" },
    loadingErrorTitle: { en: "Something went wrong", th: "เกิดข้อผิดพลาด" },
    loadingErrorBody: {
      en: "We couldn't load the exercise bank. Please try refreshing the page.",
      th: "เราไม่สามารถโหลดคลังแบบฝึกหัดได้ กรุณารีเฟรชหน้าเว็บแล้วลองอีกครั้ง",
    },
  },
  topicDetailPage: {
    loadingTitle: { en: "Loading...", th: "กำลังโหลด..." },
    loadingBody: { en: "Loading topic content...", th: "กำลังโหลดเนื้อหาหัวข้อ..." },
    notFoundTitle: { en: "Topic Not Found", th: "ไม่พบหัวข้อ" },
    notFoundBody: { en: "Topic not found", th: "ไม่พบหัวข้อ" },
    backToLibrary: { en: "← Back to Topic Library", th: "กลับไปที่คลังหัวข้อการเรียนรู้" },
    emptyContent: { en: "No content available for this topic yet.", th: "ยังไม่มีเนื้อหาสำหรับหัวข้อนี้" },
    loadingImageAlt: { en: "Loading topic", th: "กำลังโหลดหัวข้อ" },
    loadingErrorTitle: { en: "Something went wrong", th: "เกิดข้อผิดพลาด" },
    loadingErrorBody: {
      en: "We couldn't load this topic. Please try refreshing the page.",
      th: "เราไม่สามารถโหลดหัวข้อนี้ได้ กรุณารีเฟรชหน้าเว็บแล้วลองอีกครั้ง",
    },
  },
  exerciseSection: {
    title: { en: "Exercise Bank", th: "สื่อการเรียน" },
    subtitle: {
      en: "Additional practice exercises for those difficult grammar topics.",
      th: "แบบฝึกหัดเพิ่มเติมสำหรับกฎไวยากรณ์ที่เข้าใจยาก",
    },
    loadingSection: { en: "Loading section...", th: "กำลังโหลดหัวข้อ..." },
    notFound: { en: "We couldn't find that section.", th: "ไม่พบหัวข้อนี้" },
    resourcesLabel: { en: "Resources", th: "สื่อการเรียน" },
    sectionLabel: { en: "Section", th: "หัวข้อ" },
    exercisesCount: {
      singular: { en: "exercise in this section", th: "แบบฝึกหัดในหัวข้อนี้" },
      plural: { en: "exercises in this section", th: "แบบฝึกหัดในหัวข้อนี้" },
    },
    loadingImageAlt: { en: "Loading section", th: "กำลังโหลดหัวข้อ" },
    loadingErrorTitle: { en: "Something went wrong", th: "เกิดข้อผิดพลาด" },
    loadingErrorBody: {
      en: "We couldn't load this section. Please try refreshing the page.",
      th: "เราไม่สามารถโหลดหัวข้อนี้ได้ กรุณารีเฟรชหน้าเว็บแล้วลองอีกครั้ง",
    },
  },
  lessonsIndexPage: {
    stages: {
      beginner: { en: "Beginner", th: "ระดับเริ่มต้น" },
      intermediate: { en: "Intermediate", th: "ระดับกลาง" },
      advanced: { en: "Advanced", th: "ระดับสูง" },
      expert: { en: "Expert", th: "ระดับเชี่ยวชาญ" },
    },
    comingSoon: { en: "Coming Soon!", th: "เร็วๆนี้!" },
    levelLabel: { en: "Level", th: "ระดับที่" },
    levelComplete: { en: "LEVEL COMPLETE", th: "ระดับนี้จบแล้ว" },
    backstory: { en: "Backstory", th: "เรื่องราวเบื้องหลัง" },
    viewBackstory: { en: "VIEW BACKSTORY", th: "ดูหน้าเรื่องราวเบื้องหลัง" },
    hideBackstory: { en: "HIDE BACKSTORY", th: "ซ่อนหน้าเรื่องราวเบื้องหลัง" },
    lessonCheckpoint: { en: "Lesson Checkpoint", th: "จุดตรวจสอบบทเรียน" },
    locked: { en: "Locked", th: "ถูกล็อก" },
    completed: { en: "Completed", th: "จบแล้ว" },
    freePlanHeading: { en: "You're on our free plan.", th: "คุณกำลังใช้งานแพ็กเกจเรียนฟรี" },
    freePlanLine1Prefix: {
      en: "to enjoy access to our full lesson library.",
      th: "เพื่อเข้าถึงคลังบทเรียนของเราทั้งหมด",
    },
    upgrade: { en: "Upgrade", th: "อัพเกรด" },
    freePlanLine2Prefix: {
      en: "Or, explore the lessons available to you in our ",
      th: "หรือเข้าไปสำรวจบทเรียนใน ",
    },
    freeLessonLibrary: { en: "free lesson library", th: "คลังบทเรียนฟรีของเรา" },
    unlockHeading: { en: "Unlock our full Lesson Library.", th: "ปลดล็อกคลังบทเรียนทั้งหมดของเรา" },
    unlockBodyPrefix: {
      en: "All our lessons are locked. Create a free account to access our ",
      th: "ขณะนี้บทเรียนทั้งหมดของเราถูกล็อกอยู่ สร้างบัญชีผู้ใช้ฟรีเพื่อเข้าถึงบทเรียนฟรีของเรา หรือสมัครสมาชิกเพื่อเข้าถึงบทเรียนเต็มรูปแบบของเราที่มีมากกว่า 200 บทเรียน",
    },
    freeLessonsLink: { en: "free lessons", th: "บทเรียนฟรีของเรา" },
    unlockBodySuffix: {
      en: ", or become a member for full access to over 200 lessons.",
      th: "",
    },
    signUpFree: { en: "SIGN UP FOR FREE", th: "สมัครฟรี" },
    becomeMember: { en: "BECOME A MEMBER", th: "สมัครสมาชิก" },
    footerNotePrefix: { en: "Not ready to create an account?", th: "ยังไม่พร้อมสร้างบัญชีใช่ไหม?" },
    footerNoteLink: { en: "Click here", th: "คลิกที่นี่" },
    footerNoteSuffix: {
      en: "to try 4 free lessons, no sign-up required!",
      th: "เพื่อทดลองเรียนฟรี 4 บทเรียน ไม่ต้องสมัครสมาชิก!",
    },
    backstories: {
      1: {
        en: "Pailin has just moved from Bangkok to Los Angeles. She's at a summer orientation for foreign exchange students at University of California, Los Angeles (UCLA). She meets other students there and learns about her upcoming school and host family experience.",
        th: "ไพลินเพิ่งย้ายจากกรุงเทพฯ มาที่ลอสแอนเจลิส เธออยู่งานปฐมนิเทศฤดูร้อนสำหรับนักศึกษาแลกเปลี่ยนที่มหาวิทยาลัยแคลิฟอร์เนีย ลอสแอนเจลิส (UCLA) เธอได้พบกับนักศึกษาคนอื่นๆที่นั้น และได้เรียนรู้เกี่ยวกับการเรียนและการใช้ชีวิตกับครอบครัวโฮสต์ที่กำลังจะเริ่มขึ้น",
      },
      2: {
        en: "Pailin has a week of free time before moving in with her host family and starting school at UCLA! She explores different places around Los Angeles with her new friend Chloe, who she met at orientation.",
        th: "ไพลินมีเวลาว่างหนึ่งสัปดาห์ก่อนที่เธอจะย้ายเข้าไปอยู่กับครอบครัวโฮสต์ของเธอ และเริ่มเข้าเรียนที่ UCLA โดยเธอได้ไปออกสำรวจสถานที่ต่างๆรอบๆลอสแอนเจลิสกับเพื่อนใหม่ของเธอที่ชื่อโคลอี้ ซึ่งพวกเธอได้รู้จักกันจากวันปฐมนิเทศ",
      },
      3: {
        en: "Pailin meets her host family and moves into their home. With school starting in a few days, she takes time to bond with them and explore more of Los Angeles.",
        th: "ไพลินได้พบกับครอบครัวโฮสต์ของเธอ และได้ย้ายเข้าไปที่บ้านของพวกเขา ก่อนที่จะเริ่มการเรียนในอีกไม่กี่วันข้างหน้า เธอใช้เวลาในการทำความรู้จักกับพวกเขาและออกไปเที่ยวลอสแอนเจลิสเพิ่มเติม",
      },
      4: {
        en: "Pailin has started school at UCLA! She gets to know some classmates, becomes familiar with her new school, and also begins looking for a part-time job.",
        th: "ไพลินเริ่มเรียนที่ UCLA แล้ว! เธอได้รู้จักกับเพื่อนร่วมชั้นหลายคน เริ่มคุ้นเคยกับสภาพแวดล้อมใหม่ในมหาวิทยาลัยของเธอ และเริ่มหางานพาร์ทไทม์ทำ",
      },
      5: {
        en: "Pailin starts a part-time job at Skylight Books, a bookstore near UCLA. She attempts to juggle school, work, and her new friendships, all while looking forward to her birthday!",
        th: "ไพลินเริ่มทำงานพาร์ทไทม์ที่ร้านหนังสือ Skylight Books ซึ่งเป็นร้านหนังสือใกล้ๆ UCLA เธอพยายามบาลานซ์การเรียน การงาน และมิตรภาพใหม่ๆ และก็ตั้งหน้าตาตั้งรอวันเกิดของตัวเธอเองด้วย",
      },
      6: {
        en: "Pailin deepens her friendships with her host family, classmates, and coworkers. She also begins going on a few dates with guys she meets at school and through dating apps.",
        th: "ไพลินมีความสัมพันธ์ที่แน่นแฟ้นมากขึ้นทั้งกับครอบครัวโฮสต์ เพื่อนร่วมชั้น และเพื่อนที่ทำงานของเธอ และเธอยังเริ่มไปออกเดทกับผู้ชายที่เธอได้พบที่มหาวิทยาลัยและผ่านทางแอปหาคู่",
      },
      7: {
        en: "Pailin begins to feel stressed as she tries to juggle work, school, friendships, and dating. She also becomes friends with a coworker at the bookstore, Tyler.",
        th: "ไพลินเริ่มรู้สึกเครียดจากการพยายามทำหลายๆเรื่อง ไม่ว่าจะเป็นการทำงาน การเรียน มิตรภาพต่างๆ และการออกเดท เธอเริ่มสนิทกับเพื่อนร่วมงานที่ร้านหนังสือที่ชื่อไทเลอร์",
      },
      8: {
        en: "Pailin begins to feel homesick for Thailand. She spends extra time with her host family for comfort while still exploring Los Angeles with her friends.",
        th: "ไพลินเริ่มรู้สึกคิดถึงประเทศไทย เธอเริ่มหาความสบายใจโดยใช้เวลากับครอบครัวโฮสต์ของเธอมากขึ้น ขณะที่ยังออกไปสำรวจลอสแอนเจลิสกับเพื่อนๆของเธอ",
      },
      9: {
        en: "Pailin gets closer to Tyler and receives good news from her big sister Dara. She also helps out more around the house after her host mom breaks her foot. She enjoys the last few days of warm weather before it gets colder.",
        th: "ไพลินสนิทกับไทเลอร์มากขึ้นเรื่อยๆ และได้รับข่าวดีจากดารา พี่สาวของเธอ ในขณะเดียวกัน เธอก็ช่วยงานบ้านมากขึ้นหลังจากที่แม่โฮสต์ของเธอเท้าหัก และใช้เวลาอย่างสนุกสนานไปกับช่วงอากาศอบอุ่นโค้งสุดท้ายก่อนที่อากาศจะเริ่มหนาว",
      },
      10: {
        en: "Pailin looks forward to her friend Chloe’s birthday, attends a college party with her friends, and is excited to celebrate Halloween!",
        th: "ไพลินตั้งหน้าตั้งตารอวันเกิดของโคลอี้ ไปงานปาร์ตี้ของหนุ่มสาวมหาวิทยาลัยกับเพื่อนๆของเธอ และตื่นเต้นที่จะได้ฉลองฮาโลวีน!",
      },
      11: {
        en: "Pailin goes on a date with her coworker Tyler and starts to develop feelings for him. As winter approaches, she accepts an invitation to go on a ski trip with her host family and enjoys catching up with her good friends.",
        th: "ไพลินไปออกเดทกับไทเลอร์ เพื่อนร่วมงานของเธอ และเริ่มมีความรู้สึกดีๆให้กับเขา และเมื่อฤดูหนาวมาถึง เธอตอบรับคำชวนไปทริปเล่นสกีกับครอบครัวโฮสต์ของเธอ และใช้เวลาไปเที่ยวกับเพื่อนๆของเธอ",
      },
      12: {
        en: "As Pailin's relationship with Tyler becomes more serious, she learns of her host brother Luke’s dating mishaps. She is also looking forward to Thanksgiving and Black Friday!",
        th: "เมื่อความสัมพันธ์ของไพลินและไทเลอร์เริ่มมีความจริงจังมากขึ้น เธอก็รู้เรื่องปัญหาความรักของลูค พี่ชายโฮสต์ของเธอ และเธอยังตั้งตารอเทศกาลขอบคุณพระเจ้า และช่วงเทศกาลของลดราคา Black Friday",
      },
      13: {
        en: "The start of the new year is approaching, which means lots of holidays! Christmas, New Year’s, Valentine’s Day, spring break... Pailin and Tyler have just made things official - they’re now in a relationship! Pailin continues to work part-time at Skylight Books and study for her classes.",
        th: "ช่วงเริ่มต้นปีใหม่กำลังใกล้เข้ามา ซึ่งหมายถึงเทศกาลวันหยุดมากมาย! ทั้งคริสต์มาส ปีใหม่ วาเลนไทน์ และปิดเทอมฤดูใบไม้ผลิ... ไพลินและไทเลอร์เพิ่งตกลงคบกันอย่างเป็นทางการ ตอนนี้ทั้งคู่เป็นแฟนกันแล้ว! ไพลินยังคงทำงานพาร์ตไทม์ที่ร้านหนังสือ Skylight Books ควบคู่ไปกับการเรียนในคลาสของเธอ",
      },
      14: {
        en: "Pailin has just been let go from her job at Skylight Books and needs to find a new job. She looks forward to a trip with friends in the desert, continues to date her boyfriend Tyler, and starts thinking about graduation with just a few more months of school left.",
        th: "ไพลินเพิ่งถูกเลิกจ้างจากงานที่ร้านหนังสือ Skylight Books และจำเป็นต้องหางานใหม่ เธอตั้งตารอทริปไปเที่ยวทะเลทรายกับเพื่อนๆ ยังคบกับไทเลอร์แฟนของเธอต่อไป และเริ่มคิดถึงเรื่องเรียนจบ เพราะเหลือเวลาในมหาวิทยาลัยอีกเพียงไม่กี่เดือน",
      },
      15: {
        en: "Pailin has just started working as a receptionist at The Broad art museum in downtown Los Angeles. Finals are approaching at school and Pailin and her friends begin thinking of their next steps after graduation. She also starts thinking of where her relationship with Tyler is headed.",
        th: "ไพลินเพิ่งเริ่มงานใหม่ในตำแหน่งพนักงานต้อนรับที่พิพิธภัณฑ์ศิลปะ The Broad ในดาวน์ทาวน์ลอสแอนเจลิส ช่วงสอบไฟนอลที่มหาวิทยาลัยกำลังใกล้เข้ามา และไพลินกับเพื่อนๆ ก็เริ่มคิดถึงก้าวต่อไปหลังเรียนจบ เธอยังเริ่มคิดด้วยว่าความสัมพันธ์ของเธอกับไทเลอร์กำลังจะไปในทิศทางไหน",
      },
      16: {
        en: "Pailin just learned that her boyfriend Tyler was offered a job in New York, and they’re not sure if they should continue their relationship. Her UCLA graduation ceremony is in a few days and she starts planning out her next steps - move back to Thailand or stay in LA? What’s in store for Pailin and her friends after finishing university?",
        th: "ไพลินเพิ่งรู้ว่าไทเลอร์แฟนของเธอได้รับข้อเสนองานที่นิวยอร์ก และทั้งคู่ก็ยังไม่แน่ใจว่าควรไปต่อกับความสัมพันธ์นี้หรือไม่ พิธีรับปริญญาของเธอที่ UCLA กำลังจะมาถึงในอีกไม่กี่วัน และเธอก็เริ่มวางแผนก้าวต่อไปของชีวิต จะย้ายกลับประเทศไทยหรืออยู่ต่อที่ลอสแอนเจลิส? อะไรกำลังรอไพลินและเพื่อนๆ ของเธออยู่หลังเรียนจบมหาวิทยาลัย?",
      },
    },
  },
  freeLessonsIndexPage: {
    title: { en: "Free Lesson Library", th: "คลังบทเรียนฟรี" },
    subtitle: {
      en: "Explore the lessons available to you on your free plan",
      th: "เข้าสำรวจบทเรียนที่คุณเข้าได้เรียนได้ด้วยแพ็กเกจเรียนฟรี",
    },
    noAccount: {
      heading: { en: "Looks like you don't have an account.", th: "ดูเหมือนว่าคุณยังไม่มีบัญชีผู้ใช้" },
      subtextPrefix: { en: "Make a ", th: "สร้างบัญชีผู้ใช้" },
      subtextEm: { en: "free", th: "ฟรี" },
      subtextSuffix: {
        en: " account to access all the lessons below, along with access to our featured resources!",
        th: "เพื่อเข้าถึงบทเรียนด้านล่างทั้งหมด และเข้าถึงสื่อการเรียนแนะนำของเรา!",
      },
    },
    freePlan: {
      line1: {
        en: "Your free plan gives you access to the first lesson of each level!",
        th: "แพ็กเกจเรียนฟรีของคุณสามารถเข้าถึงบทเรียนแรกของทุกระดับการเรียน!",
      },
      upgradeLink: { en: "Upgrade", th: "อัพเกรด" },
      upgradeRest: { en: "to enjoy access to our ", th: "เพื่อเข้าถึง" },
      libraryLink: { en: "full lesson library", th: "คลังบทเรียนของเราทั้งหมด" },
      upgradeSuffix: { en: ".", th: "" },
    },
    stages: {
      beginner: { en: "BEGINNER", th: "ระดับเริ่มต้น" },
      intermediate: { en: "INTERMEDIATE", th: "ระดับกลาง" },
      advanced: { en: "ADVANCED", th: "ระดับสูง" },
      expert: { en: "EXPERT", th: "ระดับเชี่ยวชาญ" },
    },
    comingSoon: { en: "Coming Soon", th: "เร็วๆ นี้" },
    notCompleted: { en: "Not completed", th: "ยังไม่เสร็จ" },
  },
  tryLessonsPage: {
    title: { en: "Try Our Lessons", th: "ทดลองเรียน" },
    subtitle: {
      en: "4 free lessons for you to try, no sign-up needed!",
      th: "ลองเรียนฟรี 4 บทเรียน ไม่จำเป็นต้องสมัครสมาชิก!",
    },
    introLine1: {
      en: "We're confident you'll love our unique, narrative-driven method of learning English.",
      th: "เรามั่นใจว่าคุณจะหลงรักวิธีการเรียนภาษาอังกฤษแบบเล่าเรื่องที่ไม่เหมือนใครแบบเราแน่นอน",
    },
    introLine2: {
      en: "Explore a lesson from each level to see for yourself.",
      th: "ลองสำรวจบทเรียนแรกจากแต่ละระดับการเรียนด้วยตัวคุณเองดูก่อนสิ",
    },
    planNotice: {
      heading: { en: "Ready to continue your journey?", th: "พร้อมเรียนแล้วหรือยัง?" },
      noAccountSubtext: {
        en: "You can create a free account to unlock our entire library of free lessons.",
        th: "คุณสามารถสร้างบัญชีผู้ใช้ฟรีเพื่อปลดล็อกคลังบทเรียนฟรีทั้งหมดของเรา",
      },
      dividerPrefix: { en: "Or, get full access to ", th: "หรือ อัพเกรดเป็นสมาชิกของเราเพื่อเข้าถึง " },
      dividerEm: { en: "all 150+ lessons", th: "บทเรียนมากกว่า 200 บท" },
      dividerSuffix: {
        en: " and take your English to the next level with a full membership.",
        th: " และพัฒนายกระดับภาษาอังกฤษของคุณขึ้นไปอีกขั้น",
      },
      loggedInPrefix: { en: "Get full access to ", th: "เข้าถึง" },
      loggedInEm: { en: "all 150+ lessons", th: "บทเรียนมากกว่า 200 บททั้งหมด" },
      loggedInSuffix: {
        en: " and take your English to the next level with a full membership.",
        th: " และพัฒนายกระดับภาษาอังกฤษของคุณขึ้นไปอีกขั้นด้วยการเป็นสมาชิก",
      },
    },
  },
  resourcesPage: {
    title: { en: "Resources", th: "สื่อการเรียน" },
    subtitle: {
      en: "Extra materials to guide your English-learning journey with Pailin",
      th: "สื่อการเรียนรู้เพิ่มเติมเพื่อช่วยในการเรียนรู้ภาษาอังกฤษไปกับไพลิน",
    },
    comingSoon: { en: "Coming soon!", th: "เร็วๆนี้!" },
    cards: {
      exerciseBank: {
        title: { en: "Exercise Bank", th: "คลังแบบฝึกหัด" },
        description: {
          en: "Additional practice exercises for those difficult grammar topics",
          th: "แบบฝึกหัดเพิ่มเติมสำหรับกฎไวยากรณ์ที่เข้าใจยาก",
        },
      },
      topicLibrary: {
        title: { en: "Topic Library", th: "คลังหัวข้อการเรียนรู้" },
        description: {
          en: "Further explanations on a range of interesting ESL topics",
          th: "คำอธิบายเพิ่มเติมเกี่ยวกับห้อข้อการใช้ภาษาอังกฤษที่น่าสนใจ",
        },
      },
      commonMistakes: {
        title: { en: "Common Mistakes", th: "ข้อผิดพลาดที่พบบ่อย" },
        description: {
          en: "View our full library of common mistakes made by Thai speakers and how to fix them",
          th: "ดูคลังข้อผิดพลาดพบบ่อยที่คนไทยมักใช้ผิด พร้อมวิธีการแก้ไขให้ถูกต้อง",
        },
      },
      phrasesVerbs: {
        title: { en: "Phrases & Phrasal Verbs", th: "วลี & Phrasal Verbs" },
        description: {
          en: "Explore our bank of phrases, phrasal verbs, and slang used in our lessons",
          th: "สำรวจคลังวลี, Phrasal Verbs และคำสแลงที่ใช้ในบทเรียนต่างๆของเรา",
        },
      },
      cultureNotes: {
        title: { en: "Culture Notes", th: "เกร็ดความรู้ทางวัฒนธรรม" },
        description: {
          en: "View our full collection of Culture Notes from our lessons",
          th: "ดูคลังข้อมูลวัฒนธรรมอเมริกันทั้งหมดจากบทเรียนของเรา",
        },
      },
    },
  },
  membershipPage: {
    title: { en: "50% off for our first 200 users!", th: "ลด 50% สำหรับสมาชิก 200 คนแรก!" },
    titleHighlight: { en: "50% off", th: "ลด 50%" },
    titleRest: { en: "for our first 200 users!", th: "สำหรับสมาชิก 200 คนแรก!" },
    subtitle: {
      en: "We just launched. We want to invite you to try Pailin Abroad!",
      th: "เราเพิ่งเปิดตัว และอยากเชิญคุณมาลองใช้ Pailin Abroad!",
    },
    bestForLabel: { en: "BEST FOR:", th: "เหมาะสำหรับ:" },
    periods: {
      month: { en: "month", th: "เดือน" },
    },
    joinCta: { en: "JOIN NOW!", th: "สมัครเลย!" },
    planWarning: {
      en: "Please select a payment plan",
      th: "กรุณาเลือกแผนการชำระเงิน",
    },
    guarantee: {
      strong: { en: "100% money-back guarantee", th: "รับประกันคืนเงิน 100%" },
      body: {
        en: "within 30 days of your purchase if you're not completely satisfied with your membership. But, we're confident you'll love Pailin Abroad!",
        th: "ภายใน 30 วันหลังจากวันชำระเงิน หากคุณไม่พึงพอใจในการเป็นสมาชิกกับเรา แต่เรามั่นใจว่าคุณจะหลงรัก Pailin Abroad อย่างแน่นอนเลย!",
      },
    },
    lifetime: {
      title: { en: "LIFETIME MEMBERSHIP", th: "สมาชิกตลอดชีพ" },
      paymentLabel: { en: "One-time payment", th: "ชำระครั้งเดียว" },
      bestFor: {
        en: "Learners who want full access, forever!",
        th: "ผู้เรียนที่ต้องการเข้าถึงแบบเต็มรูปแบบตลอดไป!",
      },
      includesLabel: { en: "INCLUDES:", th: "รวม:" },
      includes: [
        {
          en: "Full access to all lessons, for life",
          th: "เข้าถึงบทเรียนทั้งหมดตลอดชีพ",
        },
        {
          en: "All future updates included at no extra cost",
          th: "อัปเดตใหม่ทั้งหมดในอนาคตโดยไม่เสียค่าใช้จ่ายเพิ่ม",
        },
        {
          en: "One simple payment, no renewals",
          th: "ชำระครั้งเดียว ไม่มีต่ออายุ",
        },
      ],
      bestValue: { en: "Best value!", th: "คุ้มที่สุด!" },
    },
    loadingImageAlt: { en: "Loading membership", th: "กำลังโหลดข้อมูลสมาชิก" },
    loadingErrorTitle: { en: "Something went wrong", th: "เกิดข้อผิดพลาด" },
    loadingErrorBody: {
      en: "We couldn't load membership pricing. Please try refreshing the page.",
      th: "เราไม่สามารถโหลดราคาสมาชิกได้ กรุณารีเฟรชหน้าเว็บแล้วลองอีกครั้ง",
    },
    plans: {
      sixMonth: {
        duration: { en: "6 MONTHS", th: "6 เดือน" },
        bestFor: {
          en: "Achieving long-term fluency and mastery",
          th: "ผู้เรียนที่ต้องการพัฒนาความคล่องแคล่วและความเชี่ยวชาญแบบระยะยาว",
        },
        savings: { en: "Save 25%", th: "ประหยัด 25%" },
      },
      threeMonth: {
        duration: { en: "3 MONTHS", th: "3 เดือน" },
        bestFor: {
          en: "Committing to consistent progress",
          th: "ผู้เรียนที่ต้องการพัฒนาอย่างต่อเนื่อง",
        },
        savings: { en: "Save 12.5%", th: "ประหยัด 12.5%" },
      },
      oneMonth: {
        duration: { en: "1 MONTH", th: "1 เดือน" },
        bestFor: {
          en: "Trying out our lessons at your own pace",
          th: "ผู้เรียนที่ต้องการทดลองเรียนด้วยความเร็วที่กำหนดเอง",
        },
      },
    },
    features: {
      title: {
        en: "Membership gives you full access to:",
        th: "สิทธิของสมาชิกที่สามารถเข้าถึงได้:",
      },
      items: [
        {
          text: {
            en: "Our whole lesson library - that’s over 200 lessons!",
            th: "คลังบทเรียนทั้งหมดของเรา มากกว่า 200 บทเรียน!",
          },
        },
        {
          text: {
            en: "Our extensive Exercise Bank",
            th: "คลังแบบฝึกหัดทั้งหมดมหาศาลของเรา",
          },
        },
        {
          text: {
            en: "Common mistakes made by Thai speakers",
            th: "ข้อผิดพลาดที่คนไทยมักใช้ผิด",
          },
        },
        {
          text: {
            en: "Our Phrases & Phrasal Verbs Bank",
            th: "คลังวลีและกริยาวลีของเรา",
          },
        },
        {
          text: {
            en: "Our ESL Topic Library",
            th: "คลังหัวข้อการเรียนรู้ภาษาอังกฤษของเรา",
          },
        },
        {
          text: {
            en: "Cultural notes to help you understand English in context",
            th: "เกร็ดความรู้ทางวัฒนธรรมที่จะช่วยให้คุณเข้าใจบริบทการใช้ภาษาอังกฤษ",
          },
        },
        {
          text: {
            en: "Comment on any lesson and get feedback from us!",
            th: "ทิ้งความคิดเห็นของคุณไว้ได้ในทุกบทเรียน พร้อมรับการตอบกลับจากเรา!",
          },
        },
      ],
    },
  },
  onboarding: {
    welcomeTitle: { en: "Welcome to Pailin Abroad!", th: "ยินดีต้อนรับเข้าสู่ Pailin Abroad!" },
    welcomeSubtitle: {
      en: "Hi, I'm Pailin! I'm so excited to be your guide on this English journey.",
      th: "สวัสดีค่ะ ฉันชื่อไพลินนะคะ! ฉันตื่นเต้นมากๆที่จะได้เป็นไกด์พาคุณเรียนรู้ภาษาอังกฤษไปด้วยกัน",
    },
    welcomeDescription: {
      en: "In a few quick steps, we'll get you ready to explore my world and the language I use every day.",
      th: "อีกในไม่กี่ขั้นตอนข้างหน้า เราจะพาคุณเตรียมพร้อมไปสำรวจโลกและภาษาอังกฤษที่ฉันใช้จริงในชีวิตประจำวันในทุกๆวันกันค่ะ",
    },
    back: { en: "Back", th: "ย้อนกลับ" },
    next: { en: "Next", th: "ถัดไป" },
    passwordTitle: { en: "Let's set up your password", th: "มาตั้งรหัสผ่านของคุณกันเถอะ" },
    emailLabel: { en: "Email address", th: "ที่อยู่อีเมล" },
    newPassword: { en: "New password", th: "รหัสผ่านใหม่" },
    confirmPassword: { en: "Confirm password", th: "ยืนยันรหัสผ่าน" },
    passwordRule1: { en: "At least 8 characters", th: "อย่างน้อย 8 ตัวอักษร" },
    passwordRule2: {
      en: "At least 1 number and 1 special character",
      th: "มีตัวเลขและอักขระพิเศษอย่างน้อยอย่างละ 1 ตัว",
    },
    passwordRule3: {
      en: "At least 1 uppercase and 1 lowercase letter",
      th: "มีตัวอักษรพิมพ์ใหญ่และพิมพ์เล็กอย่างน้อยอย่างละ 1 ตัว",
    },
    passwordMismatch: { en: "Passwords don't match", th: "รหัสผ่านไม่ตรงกัน" },
    setPassword: { en: "CREATE ACCOUNT", th: "สร้างบัญชี" },
    whatToCallYou: { en: "What should we call you?", th: "อยากให้เราเรียกคุณว่าอะไรดีล่ะ?" },
    firstNameLabel: { en: "First Name or Nickname", th: "ชื่อจริง หรือ ชื่อเล่น" },
    chooseAvatar: { en: "Choose an avatar", th: "เลือกรูปโปรไฟล์ของคุณกัน" },
    benefitsTitle: {
      en: "What's included in my free account?",
      th: "บัญชีผู้ใช้ฟรีของฉันได้สิทธิพิเศษอะไรบ้าง?",
    },
    benefit1: {
      en: "Access to the 1st lesson of each level - 16 lessons total!",
      th: "เข้าถึงบทเรียนแรกของทุกระดับการเรียน รวมทั้งหมด 16 บทเรียน!",
    },
    benefit2: {
      en: "See common mistakes made by Thai speakers",
      th: "ดูข้อผิดพลาดการใช้ภาษาที่คนไทยมักใช้ผิดบ่อยครั้ง",
    },
    benefit3: {
      en: "Access to our Featured Exercises Bank",
      th: "เข้าถึงคลังแบบฝึกหัดแนะนำของเรา",
    },
    benefit4: {
      en: "Access to our Featured Topics Library",
      th: "เข้าถึงคลังหัวข้อเรียนแนะนำต่างๆของเรา",
    },
    benefit5: {
      en: "Learn useful phrases & phrasal verbs",
      th: "เรียนรู้วลี และ phrasal verbs ที่เจ้าของภาษาใช้บ่อย",
    },
    benefit6: {
      en: "Leave comments on free lessons and get feedback from us!",
      th: "สามารถแสดงความเห็นของคุณในบทเรียนฟรี และรับคำตอบกลับจากเรา!",
    },
    confirmationTitle: { en: "You're all set!", th: "คุณพร้อมแล้ว!" },
    confirmationSubtitle: {
      en: "Your profile is complete and you're officially part of the Pailin Abroad community.",
      th: "โปรไฟล์ผู้ใช้ของคุณสมบูรณ์แล้ว และตอนนี้คุณก็ได้เป็นส่วนหนึ่งของชุมชน Pailin Abroad อย่างเป็นทางการ",
    },
    confirmationCta: { en: "Get ready to learn!", th: "มาเตรียมตัวเริ่มเรียนกันเถอะ!" },
    getStarted: { en: "GET STARTED!", th: "เริ่มเรียนเลย!" },
    avatar1: { en: "Avatar 1", th: "อวตาร 1" },
    avatar2: { en: "Avatar 2", th: "อวตาร 2" },
    avatar3: { en: "Avatar 3", th: "อวตาร 3" },
    avatar4: { en: "Avatar 4", th: "อวตาร 4" },
    avatar5: { en: "Avatar 5", th: "อวตาร 5" },
    avatar6: { en: "Avatar 6", th: "อวตาร 6" },
    avatar7: { en: "Avatar 7", th: "อวตาร 7" },
    avatar8: { en: "Avatar 8", th: "อวตาร 8" },
  },
  pathway: {
    yourNextLesson: { en: "Your next lesson:", th: "บทเรียนถัดไปของคุณ:" },
    checkpoint: { en: "Checkpoint", th: "จุดตรวจสอบ" },
    loading: { en: "Loading...", th: "กำลังโหลด..." },
    continueLearning: { en: "Continue Learning", th: "เรียนต่อ" },
    upNext: { en: "Up Next", th: "ต่อไป" },
    openLesson: { en: "Open lesson →", th: "เปิดบทเรียน →" },
    viewMyStats: { en: "View my stats →", th: "ดูสถิติของฉัน →" },
    statsPlaceholder: { en: "Stats panel coming soon", th: "หน้าสถิติจะมาเร็ว ๆ นี้" },
    allCaughtUp: { en: "You're caught up for now. More lessons are coming next.", th: "ตอนนี้คุณเรียนทันแล้ว บทเรียนถัดไปกำลังมา" },
    completedLessons: { en: "Completed Lessons", th: "บทเรียนที่เรียนจบแล้ว" },
    noCompletedLessons: {
      en: "No completed lessons yet. Start learning to see your progress here!",
      th: "ยังไม่มีบทเรียนที่เสร็จสิ้น เริ่มเรียนเพื่อดูความคืบหน้าของคุณที่นี่!",
    },
    myLikedLessons: { en: "My Liked Lessons", th: "บทเรียนที่ฉันถูกใจ" },
    likedLessonsPlaceholder: { en: "Your liked lessons will appear here.", th: "บทเรียนที่คุณชอบจะปรากฏที่นี่" },
    commentHistory: { en: "Comment History", th: "ประวัติความคิดเห็น" },
    noComments: {
      en: "No comments yet. Start engaging with lessons to see your comment history here!",
      th: "ยังไม่มีความคิดเห็น เริ่มมีส่วนร่วมกับบทเรียนเพื่อดูประวัติความคิดเห็นของคุณที่นี่!",
    },
    lessonNoLongerAvailable: { en: "Lesson no longer available", th: "บทเรียนไม่พร้อมใช้งานแล้ว" },
    pinnedComment: { en: "Pinned comment", th: "ความคิดเห็นที่ปักหมุด" },
    seeMore: { en: "See more", th: "ดูเพิ่มเติม" },
    seeLess: { en: "See less", th: "ดูน้อยลง" },
    loadingPathway: { en: "Loading your pathway...", th: "กำลังโหลดเส้นทางการเรียนของคุณ..." },
    errorPrefix: { en: "Error:", th: "ข้อผิดพลาด:" },
    noAuthToken: { en: "No authentication token found", th: "ไม่พบโทเค็นการตรวจสอบสิทธิ์" },
    welcomeBack: { en: "Welcome back,", th: "ยินดีต้อนรับกลับมานะ" },
    welcome: { en: "Welcome,", th: "ยินดีต้อนรับ" },
    user: { en: "User", th: "ผู้ใช้" },
    plan: { en: "Plan:", th: "แพ็กเกจผู้ใช้:" },
    fullAccess: { en: "Full Access", th: "เข้าถึงทุกบทเรียน" },
    freeAccess: { en: "Free", th: "ฟรี" },
    upgrade: { en: "Upgrade", th: "อัพเกรดแพ็กเกจ" },
    accountSettings: { en: "Account Settings", th: "การตั้งค่าบัญชี" },
    lessonsComplete: { en: "Lessons Complete", th: "บทเรียนที่เรียนจบแล้ว" },
    levelsComplete: { en: "Levels Complete", th: "ระดับที่เรียนจบแล้ว" },
    myPathway: { en: "My Pathway", th: "เส้นทางของฉัน" },
    completed: { en: "Completed", th: "บทเรียนที่จบแล้ว" },
    myLikedLessonsTab: { en: "My Liked Lessons", th: "บทเรียนที่ฉันถูกใจ" },
    commentHistoryTab: { en: "Comment History", th: "ประวัติความคิดเห็น" },
    goToFreeLessonLibrary: { en: "Go to our Free Lesson Library", th: "ไปที่คลังบทเรียนฟรีของเรา" },
    goToLessonLibrary: { en: "Go to Lesson Library", th: "ไปที่คลังบทเรียน →" },
    freePlanNoticeHeading: { en: "You're on our free plan.", th: "คุณกำลังใช้งานแพ็กเกจเรียนฟรี" },
    freePlanNoticeCopy: {
      en: "Upgrade to enjoy access to our full lesson library!",
      th: "อัพเกรดแพ็กเกจเพื่อเข้าถึงคลังบทเรียนของเราทั้งหมด!",
    },
    ctaBecomeMember: { en: "BECOME A MEMBER", th: "สมัครสมาชิก" },
    featuredResourcesTitle: { en: "Featured Resources", th: "สื่อการเรียนที่แนะนำ" },
    featuredResourcesFree: {
      en: "Your free plan gets you access to our featured Resource pages! Upgrade your membership to get full access!",
      th: "แพ็กเกจผู้ใช้ฟรีของคุณสามารถเข้าถึงหน้าแหล่งเรียนรู้แนะนำได้! อัพเกรดสมาชิกของคุณเพื่อเข้าถึงบทเรียนทั้งหมดของเรา!",
    },
    featuredResourcesMember: {
      en: "Your membership gets you full access to our Resource pages! Have you checked them out yet? Here are some we think you’d like!",
      th: "แพ็คเกจสมาชิกของคุณสามารถเข้าถึงหน้าแหล่งเรียนรู้ทั้งหมดแล้ว! ลองเข้าไปดูแล้วหรือยังคะ? นี่คือบางส่วนที่เราคิดว่าคุณน่าจะชอบนะ!",
    },
    featuredResourcesCta: { en: "SEE ALL RESOURCES", th: "ดูหน้าแหล่งเรียนรู้ทั้งหมด" },
    profileAvatar: { en: "Profile Avatar", th: "รูปโปรไฟล์" },
    lessonCheckpoint: { en: "Lesson Checkpoint", th: "จุดตรวจสอบบทเรียน" },
    notCompleted: { en: "Not completed", th: "ยังไม่เสร็จสิ้น" },
    completedAlt: { en: "Completed", th: "เสร็จสิ้นแล้ว" },
    locked: { en: "Locked", th: "ถูกล็อก" },
    lessonTitle: { en: "Lesson Title", th: "ชื่อบทเรียน" },
    viewLabel: { en: "View", th: "ดู" },
    loadingImageAlt: { en: "Loading pathway", th: "กำลังโหลดเส้นทางการเรียน" },
    loadingErrorTitle: { en: "Something went wrong", th: "เกิดข้อผิดพลาด" },
    loadingErrorBody: {
      en: "We couldn't load your pathway. Please try again.",
      th: "เราไม่สามารถโหลดเส้นทางการเรียนของคุณได้ กรุณาลองอีกครั้ง",
    },
    retry: { en: "TRY AGAIN", th: "ลองอีกครั้ง" },
  },
  accountSettings: {
    title: { en: "Account Settings", th: "การตั้งค่าบัญชี" },
    editProfileTab: { en: "Edit Profile", th: "แก้ไขบัญชีโปรไฟล์" },
    subscriptionBillingTab: { en: "Subscription & Billing", th: "การสมัครสมาชิก & การชำระเงิน" },
    myProfileTitle: { en: "My Profile", th: "โปรไฟล์ของฉัน" },
    avatarLabel: { en: "Avatar", th: "รูปโปรไฟล์" },
    firstNameLabel: { en: "First Name", th: "ชื่อ" },
    emailAddressLabel: { en: "Email Address", th: "อีเมล" },
    passwordLabel: { en: "Password", th: "รหัสผ่าน" },
    save: { en: "Save", th: "บันทึก" },
    edit: { en: "Edit", th: "แก้ไข" },
    changePassword: { en: "Change Password", th: "เปลี่ยนรหัสผ่าน" },
    manageAccount: { en: "Manage My Account", th: "จัดการบัญชีของฉัน" },
    logout: { en: "Log Out", th: "ออกจากระบบ" },
    deleteAccount: { en: "Delete Account", th: "ลบบัญชี" },
    deleteConfirm: {
      en: "Are you sure you want to delete your account? This action cannot be undone.",
      th: "หากต้องการลบบัญชีของคุณ กรุณาคลิกด้านล่าง โปรดทราบว่าการลบบัญชีผู้ใช้ของคุณนั้นเป็นการดำเนินการที่ถาวร ไม่สามารถกู้คืนบัญชีได้ โดยข้อมูลส่วนตัว บันทึกการเรียน และการตั้งค่าบัญชีทั้งของคุณจะถูกลบออกอย่างถาวร",
    },
    deleteSuccess: { en: "Account deleted successfully.", th: "ลบบัญชีสำเร็จแล้ว" },
    deleteError: {
      en: "An error occurred while deleting your account. Please try again.",
      th: "เกิดข้อผิดพลาดระหว่างลบบัญชี กรุณาลองใหม่อีกครั้ง",
    },
    currentPlan: { en: "Current plan:", th: "แพ็กเกจผู้ใช้ปัจจุบัน:" },
    freePlan: { en: "FREE", th: "ฟรี" },
    includedInPlan: { en: "Included in plan:", th: "สิ่งที่รวมอยู่ในแพ็คเกจ:" },
    fullLibraryCta: { en: "Want access to our full lesson library?", th: "อยากเข้าถึงคลังบทเรียนทั้งหมดของพวกเราใช่ไหมล่ะ?" },
    becomeMember: { en: "BECOME A MEMBER", th: "สมัครสมาชิก" },
    resetEmailSent: {
      en: "Password reset email sent. Please check your inbox.",
      th: "ส่งอีเมลรีเซ็ตรหัสผ่านแล้ว กรุณาตรวจสอบกล่องจดหมายของคุณ",
    },
    incorrectPassword: { en: "Incorrect password. Please try again.", th: "รหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง" },
    confirmPasswordFail: { en: "Failed to confirm password.", th: "ยืนยันรหัสผ่านไม่สำเร็จ" },
    profileAvatarAlt: { en: "Profile Avatar", th: "รูปโปรไฟล์" },
    changeAvatarAria: { en: "Change avatar", th: "เปลี่ยนรูปโปรไฟล์" },
    chooseAvatarAria: { en: "Choose avatar", th: "เลือกรูปโปรไฟล์" },
    selectableAvatarAlt: { en: "Selectable avatar", th: "รูปโปรไฟล์ให้เลือก" },
  },
  subscriptionBilling: {
    loading: { en: "Loading subscription details...", th: "กำลังโหลดข้อมูลการสมัครสมาชิก..." },
    retry: { en: "Retry", th: "ลองอีกครั้ง" },
    freePlanTitle: { en: "You are on our free plan.", th: "คุณกำลังใช้งานแพ็กเกจเรียนฟรี" },
    freePlanSubtitle: { en: "To upgrade your membership, click here.", th: "เพื่ออัพเกรดแพ็คเกจสมาชิกของคุณ คลิกที่นี่" },
    freePlanCta: { en: "BECOME A MEMBER", th: "สมัครสมาชิก" },
    subscriptionTitle: { en: "SUBSCRIPTION", th: "การสมัครสมาชิก" },
    currentPlanLabel: { en: "Current Plan", th: "แพ็กเกจผู้ใช้ปัจจุบัน" },
    cancelsOn: { en: "Cancels On", th: "ยกเลิกในวันที่" },
    premiumMonthly: { en: "Premium Monthly", th: "Premium Monthly" },
    nextBillingLabel: { en: "Next Billing Date", th: "วันเรียกเก็บเงินรอบถัดไป" },
    priceLabel: { en: "Price", th: "ยอดที่จะถูกเรียกเก็บ" },
    priceMonthly: { en: "฿400/month", th: "฿400/เดือน" },
    statusLabel: { en: "Status", th: "สถานะ" },
    changePlan: { en: "CHANGE PLAN", th: "เปลี่ยนแพ็คเกจผู้ใช้" },
    opening: { en: "OPENING...", th: "กำลังเปิด..." },
    billingTitle: { en: "BILLING", th: "ข้อมูลการเรียกเก็บเงิน" },
    expires: { en: "Expires", th: "วันหมดอายุ" },
    edit: { en: "EDIT", th: "แก้ไข" },
    noPayment: { en: "No payment method on file", th: "ไม่มีข้อมูลการชำระเงิน" },
    billingHistory: { en: "BILLING HISTORY", th: "ประวัติการเรียกเก็บเงิน" },
    noHistory: { en: "No billing history available", th: "ยังไม่มีประวัติการเรียกเก็บเงิน" },
    download: { en: "DOWNLOAD", th: "ดาวน์โหลด" },
    cancelTitle: { en: "CANCEL MEMBERSHIP", th: "ยกเลิกสมาชิก" },
    cancelWarning: {
      en: "Cancelling your membership will remove access to all premium features at the end of your current billing period.",
      th: "การยกเลิกสมาชิกของคุณจะทำให้การเข้าถึงคลังบทเรียนทั้งหมดของคุณสิ้นสุดลงเมื่อรอบการเรียกเก็บเงินรอบปัจจุบันเสร็จสิ้น",
    },
    keepSubscription: { en: "KEEP SUBSCRIPTION", th: "คงสมาชิกไว้" },
    cancelConfirm: {
      en: "Are you absolutely sure? This action cannot be undone.",
      th: "คุณแน่ใจหรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้",
    },
    cancelYes: { en: "YES, CANCEL", th: "ใช่ ยกเลิก" },
    canceling: { en: "CANCELLING...", th: "กำลังยกเลิก..." },
  },
  paymentSuccess: {
    verifiedTitle: { en: "Payment Successful!", th: "การชำระเงินสำเร็จแล้ว!" },
    verifiedSubtitle: { en: "Welcome to Pailin Abroad Premium!", th: "ตอนนี้คุณเป็นสมาชิกของ Pailin Abroad แล้ว!" },
    verifiedMessage: {
      en: "Your membership is now active. You now have full access to all lessons and features.",
      th: "ขอบคุณที่เข้าร่วมมาเป็นส่วนหนึ่งของ Pailin Abroad!",
    },
    goToPathway: { en: "Go to My Pathway", th: "ไปที่เส้นทางการเรียนของฉัน" },
    returnHome: { en: "Return to Homepage", th: "กลับไปที่หน้าแรก" },
    unverifiedTitle: {
      en: "Payment Received!",
      th: "การชำระเงินของคุณสำเร็จแล้ว! ยินดีต้อนรับสู่ Pailin Abroad",
    },
    unverifiedSubtitle: { en: "One More Step...", th: "กรุณายืนยันอีเมลของคุณ" },
    unverifiedMessagePrefix: {
      en: "We've sent you a verification email. Please check your inbox and click the verification link to activate your account and access all lessons.",
      th: "เราได้ส่งอีเมลยืนยันไปให้คุณที่ ",
    },
    unverifiedMessageSuffix: { en: "", th: " แล้ว กรุณาคลิกที่ลิงค์ในอีเมลเพื่อยืนยันบัญชีของคุณ" },
    unverifiedNote: {
      en: "Once verified, you can log in and start learning!",
      th: "หากคุณไม่ได้รับอีเมลภายในไม่กี่นาที กรุณาตรวจสอบโฟลเดอร์สแปมหรือจดหมายขยะภายในอีเมลของคุณ หรือคลิกปุ่มทางด้านล่างเพื่อทำการส่งอีเมลอีกครั้ง",
    },
    resendEmail: { en: "Resend Verification Email", th: "ส่งอีเมลอีกครั้ง" },
    sending: { en: "Sending...", th: "กำลังส่ง..." },
    noEmail: { en: "Error: No email found", th: "ข้อผิดพลาด: ไม่พบอีเมล" },
    resendSuccess: { en: "Verification email sent! Check your inbox.", th: "ส่งอีเมลยืนยันแล้ว! กรุณาตรวจสอบกล่องจดหมายของคุณ" },
    resendFail: { en: "Failed to send email. Please try again.", th: "ส่งอีเมลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง" },
    returnHomeToLogin: { en: "Return to Homepage to Log In", th: "กลับไปที่หน้าแรกเพื่อเข้าสู่ระบบ" },
  },
  quickSignup: {
    title: { en: "Create an Account", th: "สร้างบัญชีผู้ใช้" },
    subtitle: { en: "Sign Up to continue to checkout", th: "สมัครสมาชิกเพื่อไปต่อที่หน้าชำระเงิน" },
    emailLabel: { en: "Email", th: "อีเมล" },
    emailPlaceholder: { en: "your@email.com", th: "your@email.com" },
    passwordLabel: { en: "Password", th: "รหัสผ่าน" },
    passwordPlaceholder: { en: "Enter password", th: "กรอกรหัสผ่าน" },
    confirmPasswordLabel: { en: "Confirm Password", th: "ยืนยันรหัสผ่าน" },
    confirmPasswordPlaceholder: { en: "Confirm password", th: "ยืนยันรหัสผ่าน" },
    submit: { en: "Sign Up", th: "สมัครสมาชิก" },
    submitting: { en: "Signing up...", th: "กำลังสมัครสมาชิก..." },
    alreadyHaveAccount: { en: "Already have an account?", th: "มีบัญชีอยู่แล้ว?" },
    loginLink: { en: "Log in", th: "เข้าสู่ระบบ" },
    passwordMismatch: { en: "Passwords do not match", th: "รหัสผ่านไม่ตรงกัน" },
    passwordTooShort: { en: "Password must be at least 8 characters", th: "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร" },
    passwordRequirements: {
      en: "Password must include uppercase and lowercase letters, a number, and a symbol",
      th: "รหัสผ่านต้องมีตัวอักษรพิมพ์ใหญ่ พิมพ์เล็ก ตัวเลข และสัญลักษณ์",
    },
    passwordRule1: { en: "At least 8 characters", th: "อย่างน้อย 8 ตัวอักษร" },
    passwordRule2: {
      en: "At least 1 number and 1 special character",
      th: "มีตัวเลขและอักขระพิเศษอย่างน้อยอย่างละ 1 ตัว",
    },
    passwordRule3: {
      en: "At least 1 uppercase and 1 lowercase letter",
      th: "มีตัวอักษรพิมพ์ใหญ่และพิมพ์เล็กอย่างน้อยอย่างละ 1 ตัว",
    },
    signupError: { en: "An error occurred during signup. Please try again.", th: "เกิดข้อผิดพลาดระหว่างสมัครสมาชิก กรุณาลองใหม่อีกครั้ง" },
    successTitle: { en: "Account Created!", th: "สร้างบัญชีสำเร็จ!" },
    successMessage: {
      en: "We've sent you a verification email. You can proceed to checkout now and verify your email later.",
      th: "เราได้ส่งอีเมลยืนยันให้คุณแล้ว คุณสามารถไปต่อที่หน้าชำระเงินได้เลย และค่อยยืนยันอีเมลภายหลัง",
    },
    continueCheckout: { en: "Continue to Checkout", th: "ไปต่อที่หน้าชำระเงิน" },
    verifyNote: { en: "Please verify your email to unlock all features", th: "กรุณายืนยันอีเมลเพื่อปลดล็อกทุกฟีเจอร์" },
  },
  aboutPage: {
    title: { en: "About Pailin Abroad", th: "เกี่ยวกับ Pailin Abroad" },
    subtitle: {
      en: "Learn all you need to know about us - our method, our team, and our story!",
      th: "มาทำความรู้จักเกี่ยวกับเรากัน ไม่ว่าจะเป็นวิธีการเรียน ทีมงาน และเรื่องราวของเรา!",
    },
    sectionMethod: { en: "The Method", th: "วิธีการเรียนของเรา" },
    sectionTeam: { en: "Our Team", th: "ทีมงานของเรา" },
  },
  aboutMethod: {
    card1Header: { en: "What is the Pailin Abroad method?", th: "วิธีการเรียนในแบบของ Pailin Abroad คืออะไร?" },
    card1P1: {
      en: "Pailin Abroad is a narrative-driven English learning platform with over 150 lessons, each based on a conversation. Instead of memorizing disconnected grammar rules or vocabulary lists, you'll follow a continuous story that follows Pailin’s life in Los Angeles, which gives you an engaging and natural way of learning English in context.",
      th: "Pailin Abroad เป็นแพลตฟอร์มการเรียนการสอนภาษาอังกฤษ ที่มีบทเรียนมากกว่า 150 บทเรียนผ่านเรื่องราวต่างๆ ที่อิงจากบทสนทนา แทนที่จะใช้วิธีการท่องจำกฎไวยากรณ์หรือคำศัพท์แบบแยกส่วนกัน คุณจะได้เรียนรู้ผ่านเรื่องราวที่มีความต่อเนื่องของชีวิตไพลินในเมืองลอสแอนเจลิส ซึ่งจะช่วยให้คุณได้เรียนรู้ภาษาอังกฤษจากในบริบท ด้วยวิธีการเรียนรู้ที่เป็นธรรมชาติและน่าสนใจ",
    },
    card2Header: { en: "Who is Pailin?", th: "ไพลินคือใคร?" },
    card2P1: {
      en: "Pailin is a 21-year-old girl from Bangkok who will study abroad in Los Angeles for a year.",
      th: "ไพลินคือสาววัย 21 ปีจากกรุงเทพฯ ที่เดินทางไปเรียนต่อต่างประเทศที่เมืองลอสแอนเจลิสเป็นเวลา 1 ปี",
    },
    card2P2: {
      en: "You’ll follow her journey as she navigates friendship, love, family, school, work, and life in a new country. As you get to know Pailin and the other characters, you’ll feel connected to their stories and be motivated to move through the narrative, all while improving your English along the way.",
      th: "คุณจะได้ติดตามเส้นทางชีวิตการเดินทางของเธอ ไม่ว่าจะเป็นเรื่องมิตรภาพ ความรัก ครอบครัว การเรียน การทำงาน และการใช้ชีวิตในต่างประเทศ เมื่อคุณได้ทำความรู้จักกับไพลินและตัวละครอื่นๆมากขึ้น คุณจะรู้สึกผูกพันกับเรื่องราวของพวกเขา และมีแรงจูงใจในการเรียนรู้ไปกับเรื่องราวเหล่านี้ พร้อมทั้งพัฒนาภาษาอังกฤษของคุณไปด้วยในเวลาเดียวกัน",
    },
    card2DidYouKnow: {
      en: "Did you know? You can see what Pailin is up to in LA on Instagram! @pailinabroad ✨",
      th: "รู้ไหม ว่าคุณสามารถติดตามดูชีวิตของไพลินในแอลเอได้ทาง Instagram ที่ @pailinabroad ได้ด้วยนะ!",
    },
    card3Header: { en: "What kind of English will I learn?", th: "ฉันจะได้เรียนภาษาอังกฤษแบบไหน?" },
    card3P1: {
      en: "You’ll learn natural, conversational English with Pailin Abroad - the English that native speakers actually use.",
      th: "คุณจะได้เรียนรู้ภาษาอังกฤษที่เป็นธรรมชาติจากบทสนทนาจริง ไปพร้อมกับ Pailin Abroad และเป็นภาษาอังกฤษที่เจ้าของภาษานั้นใช้จริงๆ",
    },
    card3P2: {
      en: "Many ESL resources teach stiff, formal English that sounds awkward in casual conversation. We skip that textbook formality and focus on the real-life conversations you’ll have with friends, family, coworkers, romantic interests, and strangers.",
      th: "สื่อการเรียนภาษาอังกฤษหลายๆแห่งนั้นสอนภาษาอังกฤษที่มีรูปแบบเป็นทางการและดูแข็งทื่อ ทำให้ฟังดูไม่เป็นธรรมชาติเมื่อนำมาใช้ในบทสนทนาจริง เราจะข้ามการเรียนในแบบตามตำรา และเน้นไปที่บทสนทนาที่ได้ใช้จริง ที่คุณสามารถใช้กับเพื่อนๆ ครอบครัว เพื่อนร่วมงาน คนที่คุณมีความสนใจ และรวมไปถึงคนแปลกหน้า",
    },
    card3P3: {
      en: "Our goal is to help you use English to show your true personality. The characters in Pailin Abroad get excited, sad, angry, annoyed, confused, and embarrassed - just like all of us! Through their real-life dialogues, you’ll learn authentic ways to express your feelings in English.",
      th: "เป้าหมายของเราคือช่วยให้คุณได้ใช้ภาษาอังกฤษเพื่อแสดงความเป็นตัวตนที่แท้จริงออกมา ตัวละครใน Pailin Abroad นั้นได้มีการแสดงออกทั้งความตื่นเต้น เศร้า โกรธ หงุดหงิด สับสน และอับอาย ซึ่งก็เหมือนกับพวกเราทุกคนนั่นแหละ! ผ่านบทสนทนาในชีวิตจริงของพวกเขา คุณจะได้เรียนรู้การแสดงความรู้สึกของคุณเป็นภาษาอังกฤษอย่างเป็นธรรมชาติ",
    },
    card4Header: { en: "What English level is Pailin Abroad for?", th: "Pailin Abroad เหมาะกับผู้เรียนภาษาอังกฤษระดับไหน?" },
    card4P1: {
      en: "Pailin Abroad is designed to support all levels of English learners! We offer Beginner, Intermediate, Advanced, and Expert levels.",
      th: "Pailin Abroad ถูกออกแบบเพื่อรองรับผู้เรียนภาษาอังกฤษทุกระดับ! เรามีระดับบทเรียนตั้งแต่ระดับเริ่มต้น (Beginner), ระดับกลาง (Intermediate), ระดับสูง (Advanced) จนถึงระดับเชี่ยวชาญ (Expert)",
    },
    card4P2: {
      en: "Level 1 of our Beginner course is perfect if you’re starting your English learning from scratch.",
      th: "บทเรียนระดับ 1 ของคอร์สเริ่มต้น (Beginner) นั้นเหมาะอย่างยิ่งหากคุณกำลังเริ่มเรียนภาษาอังกฤษตั้งแต่พื้นฐาน",
    },
    card4P3: {
      en: "Best of all, you’re not stuck on a pathway - you can jump into any level that suits your skills. But we think that more advanced learners will still find our beginner lessons interesting and insightful!",
      th: "และที่ดีที่สุดก็คือ คุณไม่ต้องเรียนตามเส้นทางที่กำหนดตายตัว คุณสามารถกระโดดเข้าไปเรียนในระดับที่เหมาะกับทักษะของคุณได้เลย แต่เราก็มั่นใจว่าผู้เรียนระดับสูงๆจะพบว่าบทเรียนระดับเริ่มต้นของเราน่าสนใจและมีมุมมองใหม่ๆด้วย",
    },
    card5Header: { en: "How does Pailin Abroad specifically benefit Thai people?", th: "Pailin Abroad ช่วยผู้เรียนชาวไทยได้อย่างไร?" },
    card5Intro: {
      en: "There are two huge advantages that Pailin Abroad offers for Thai people:",
      th: "Pailin Abroad มีข้อดีใหญ่ๆสำหรับผู้เรียนชาวไทยอยู่ 2 อย่าง:",
    },
    card5Strong1: { en: "All content is translated in English and Thai", th: "เนื้อหาการเรียนทั้งหมดมีทั้งภาษาอังกฤษและภาษาไทย" },
    card5P1: {
      en: "Most ESL resources are only available in English, so they’re not beginner-friendly! Or, you must use Google Translate for all the content, which leads to wildly inaccurate translations. With Pailin Abroad, you don’t have to worry about this - you can just focus on learning.",
      th: "สื่อการเรียนภาษาอังกฤษส่วนใหญ่จะมีเฉพาะภาษาอังกฤษ จึงทำให้ไม่เหมาะกับผู้เรียนมือใหม่! หรือไม่คุณก็ต้องใช้ Google Translate แปลเนื้อหาทั้งหมดออกมา ซึ่งมักแปลออกมาไม่ถูกต้อง แต่กับ Pailin Abroad นั้น คุณไม่ต้องกังวลในเรื่องนี้เลย คุณแค่โฟกัสไปที่การเรียนรู้ก็พอ",
    },
    card5Strong2: {
      en: "All lessons are created by native English speakers who lived in Thailand for years",
      th: "บทเรียนทั้งหมดถูกเขียนขึ้นโดยเจ้าของภาษาที่เคยอาศัยอยู่ในประเทศไทยมาหลายปี",
    },
    card5P2: {
      en: "We understand the unique challenges that Thai people face when learning English. Our Common Mistakes library gives specific insights into the mistakes that Thai people often make, and why. We also offer ways to fix these mistakes!",
      th: "เรามีความเข้าใจในปัญหาที่ผู้เรียนชาวไทยมักประสบพบเจอเมื่อเรียนภาษาอังกฤษ คลังที่เรารวบรวมข้อผิดพลาดที่พบบ่อยที่คนไทยมักทำนั้น จะช่วยอธิบายข้อผิดพลาด พร้อมเหตุผลว่าทำไมถึงใช้ผิด และให้วิธีการแก้ไขในการใช้ภาษาอีกด้วย",
    },
    card6Header: {
      en: "How will Pailin Abroad help me improve my English in the real world?",
      th: "Pailin Abroad จะช่วยให้ฉันพัฒนาภาษาอังกฤษของฉันในชีวิตประจำวันได้อย่างไร?",
    },
    card6StrongIntro: { en: "Has this ever happened to you?", th: "นี่เคยเกิดขึ้นกับคุณมาก่อนไหม?" },
    card6P1: {
      en: "You study English and feel confident in your skills, but then a native speaker talks so quickly and uses so much slang! You freeze, and suddenly all the English you learned has disappeared.",
      th: "คุณเรียนภาษาอังกฤษมา และรู้สึกมั่นใจในภาษาของคุณ แต่พอเอาเข้าจริง เจ้าของภาษาพูดเร็วมาก และใช้คำสแลงเยอะมากๆ! คุณกลับพูดไม่ออก และจู่ๆมันก็เหมือนว่าภาษาอังกฤษที่คุณเรียนมาทั้งชีวิตนั้นหายไปทันที",
    },
    card6P2: {
      en: "We totally get it! That's what happens when you learn English out of context, usually from outdated textbooks in the classroom.",
      th: "เราเข้าใจความรู้สึกนี้ดีเลย! นั่นเป็นสิ่งที่จะเกิดขึ้นเมื่อคุณเรียนภาษาอังกฤษมาแบบไม่มีบริบท ซึ่งมักมาจากตำราเรียนในห้องเรียนแบบเก่าๆ",
    },
    card6P3: {
      en: "In real life, you can't always ask people to slow down or repeat themselves. But with Pailin Abroad, you are in control. You can slow down the audio, replay the conversation, and listen as many times as you need until you fully grasp the dialogue. Soon enough, you’ll stop translating every single word into Thai in your head, and you’ll start naturally understanding English at a real-life pace.",
      th: "ในชีวิตจริงนั้น คุณไม่สามารถขอให้คนอื่นพูดช้าลง หรือพูดซ้ำๆให้เราได้อยู่ตลอดหรอกนะ แต่การเรียนกับ Pailin Abroad นั้น คุณเป็นคนควบคุมการเรียนรู้เองได้เลย คุณสามารถปรับความเร็วของไฟล์เสียง ฟังบทสนทนาซ้ำ และฟังกี่รอบก็ได้เท่าที่คุณต้องการ จนกว่าคุณจะเข้าใจเนื้อหาอย่างแท้จริง ไม่นานนักหรอก เดี๋ยวคุณก็จะหยุดแปลการพูดทุกคำเป็นภาษาไทยในหัวของคุณ และเริ่มเข้าใจภาษาอังกฤษขึ้นเรื่อยๆอย่างเป็นธรรมชาติในความเร็วที่ใช้ในชีวิตจริงเลยล่ะ",
    },
    card7Header: { en: "What’s included in each lesson?", th: "ในหนึ่งบทเรียนมีอะไรบ้าง?" },
    card7Intro: {
      en: "Each lesson contains all or most of these items, in this specific flow to guide your practice:",
      th: "แต่ละบทเรียนจะประกอบไปด้วยองค์ประกอบเหล่านี้ โดยเรียงลำดับอย่างเป็นขั้นตอนเพื่อเป็นแนวทางในการช่วยคุณฝึกใช้ภาษา",
    },
    card7AudioTitle: { en: "Audio Conversation", th: "บทสนทนาเสียง" },
    card7AudioBody: {
      en: "Slow down and relisten to the conversation as many times as you need! Try not to look at the translation first - see how much you can understand just by listening.",
      th: "ปรับความเร็วไฟล์เสียงลงและฟังบทสนทนาซ้ำได้บ่อยเท่าที่คุณต้องการ พยายามอย่าดูที่คำแปลก่อน ลองฟังดูก่อนว่าคุณเข้าใจมากน้อยแค่ไหน",
    },
    card7FocusTitle: { en: "Lesson Focus", th: "ประเด็นหลักของบทเรียน" },
    card7FocusBody: {
      en: "Each lesson revolves around one grammar point or key concept that’s used throughout the conversation, so you can hear it in a natural context.",
      th: "แต่ละบทเรียนจะโฟกัสไปที่กฎไวยากรณ์หรือแนวคิดสำคัญเพียงหนึ่งเรื่อง ที่จะถูกใช้ตลอดบทสนทนา คุณจึงจะได้ยินการใช้ในบริบทที่มีความเป็นธรรมชาติ",
    },
    card7ComprehensionTitle: { en: "Comprehension Questions", th: "คำถามเพื่อทดสอบความเข้าใจ" },
    card7ComprehensionBody: {
      en: "Test your overall understanding of the conversation.",
      th: "ทดสอบความเข้าใจภาพรวมของบทสนทนา",
    },
    card7ApplyTitle: { en: "Apply", th: "การนำไปใช้" },
    card7ApplyBody: {
      en: "This is your chance to try using the lesson focus in a sentence on your own before learning about it! This will help concepts stick better in your brain.",
      th: "นี่เป็นโอกาสของคุณที่จะลองใช้กฎไวยากรณ์ที่อยู่ในประเด็นหลักของบทเรียนด้วยการแต่งประโยคของตัวเอง ก่อนที่จะเริ่มเรียนจริง! นี่จะช่วยให้คุณจำเนื้อหาได้ดียิ่งขึ้น",
    },
    card7UnderstandTitle: { en: "Understand", th: "การทำความเข้าใจ" },
    card7UnderstandBody: {
      en: "Dive into the lesson focus, using the conversation for context. Listen to example sentences with audio to further practice your listening and comprehension skills.",
      th: "เจาะลึกประเด็นหลักของบทเรียนโดยใช้บทสนทนาเป็นบริบท กดฟังประโยคการใช้ตัวอย่างเพื่อฝึกการฟังและความเข้าใจของคุณมากยิ่งขึ้น",
    },
    card7TipsTitle: { en: "Extra Tips", th: "เคล็ดลับเพิ่มเติม" },
    card7TipsBody: {
      en: "These are tips that can further your understanding of the lesson focus.",
      th: "ส่วนนี้จะเป็นทริคเพิ่มเติมที่จะช่วยให้คุณเข้าใจประเด็นหลักของบทเรียนมากขึ้น",
    },
    card7MistakesTitle: { en: "Common Mistakes", th: "ข้อผิดพลาดที่พบบ่อย" },
    card7MistakesBody: {
      en: "These are common mistakes made by Thai people, along with ways to fix them.",
      th: "นี่เป็นข้อผิดพลาดทางการใช้ที่คนไทยมักทำผิดพลาด พร้อมคำอธิบายและวิธีการแก้ใขในการใช้ที่ถูกต้อง",
    },
    card7PhrasesTitle: { en: "Phrases & Phrasal Verbs", th: "วลีและ Phrasal Verbs ต่างๆ" },
    card7PhrasesBody: {
      en: "We’ve highlighted the important phrases and phrasal verbs used in the conversation, complete with examples of them used in a sentence.",
      th: "เราได้ทำการเน้นวลีและ phrasal verbs ที่สำคัญๆที่ใช้ในบทสนทนาไว้ให้ พร้อมทั้งไฟล์เสียงตัวอย่างการใช้ในประโยคจริง",
    },
    card7CultureTitle: { en: "Culture Notes", th: "เกร็ดความรู้ทางวัฒนธรรม" },
    card7CultureBody: {
      en: "These are insights into American culture that are mentioned in the conversation that you will find interesting or useful to know.",
      th: "ส่วนนี้เป็นข้อมูลเชิงลึกในด้านวัฒนธรรมอเมริกันที่ถูกกล่าวถึงในบทสนทนา ที่คุณจะพบว่ามันน่าสนใจและมีประโยชน์",
    },
    card7PracticeTitle: { en: "Practice", th: "แบบฝึกหัด" },
    card7PracticeBody: {
      en: "Every lesson has practice exercises for you to complete to further your understanding of the lesson focus.",
      th: "ทุกบทเรียนมีแบบฝึกหัดให้คุณทำ เพื่อเสริมความเข้าใจในประเด็นหลักของบทเรียน",
    },
    card7CommentTitle: { en: "Comment", th: "การแสดงความคิดเห็น" },
    card7CommentBody: {
      en: "Practice your writing skills by responding to the Pinned Comment! We’ll respond with personalized feedback and corrections.",
      th: "ฝึกทักษะการเขียนของคุณโดยตอบกลับคอมเมนต์ที่ปักหมุดไว้! เราจะตอบกลับพร้อมให้คำแนะนำและแก้ไขข้อผิดพลาดให้แบบส่วนตัวเลยล่ะ!",
    },
    card8Header: { en: "Who is Pailin Abroad best for?", th: "Pailin Abroad เหมาะกับใครที่สุด?" },
    card8P1: {
      en: "You’ve definitely heard this advice for learning a language: ‘Just go out there and start speaking!’",
      th: "คุณคงจะเคยได้ยินคำแนะนำในการเรียนภาษาแบบนี้มาบ้างแล้วว่า ‘ก็แค่ออกไปฝึกใช้ข้างนอก และก็เริ่มพูดบ่อยๆเอง!’",
    },
    card8P2: {
      en: "But the truth is, not all of us are naturally gifted at learning a language just by immersion alone.",
      th: "แต่ความจริงก็คือ ไม่ใช่ทุกคนที่จะเก่งมีพรสวรรค์ในการเรียนภาษา จากการซึมซับมาเพียงอย่างเดียวเท่านั้น",
    },
    card8P3: {
      en: "Pailin Abroad is designed to be a comfortable, structured space to practice your English and build your confidence. By greatly improving your listening skills with our lessons, you’ll no longer feel intimidated to talk with native English speakers!",
      th: "Pailin Abroad ถูกออกแบบมาให้เป็นพื้นที่ที่เป็นระบบ แต่ก็สบายๆในการฝึกใช้ภาษาอังกฤษของคุณ และช่วยสร้างความมั่นใจให้กับคุณ เมื่อทักษะการฟังของคุณพัฒนาขึ้นแบบขีดสุดไปกับบทเรียนของเรา คุณก็ไม่ต้องกลัวการพูดกับเจ้าของภาษาอีกต่อไป!",
    },
  },
  contactPage: {
    title: { en: "Contact Us", th: "ติดต่อเรา" },
    subtitle: {
      en: "We love to hear from you! Ask us your questions or leave your feedback.",
      th: "พวกเราอยากได้ยินความคิดเห็นจากคุณ! ถามคำถามหรือทิ้งความคิดเห็นของคุณให้เราได้เลย",
    },
    cardBody: {
      en: "We’re here to help. Please check out our FAQ page to see if your question has already been answered. To contact us with further questions or feedback, please message us through any of the following platforms, or fill out the form below.",
      th: "หรือส่งข้อความให้เราที่นี่:",
    },
    statusSendingMessage: { en: "Sending your message...", th: "กำลังส่งข้อความของคุณ..." },
    statusSuccess: { en: "Message sent successfully! We'll get back to you soon.", th: "ส่งข้อความสำเร็จแล้ว! เราจะติดต่อกลับโดยเร็วที่สุด" },
    statusError: { en: "Error sending message. Please try again.", th: "ส่งข้อความไม่สำเร็จ กรุณาลองใหม่อีกครั้ง" },
    statusUnexpected: { en: "Something went wrong. Please try again.", th: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง" },
    nameLabel: { en: "Name", th: "ชื่อ" },
    namePlaceholder: { en: "Name", th: "ชื่อ" },
    emailLabel: { en: "Email", th: "อีเมล" },
    emailPlaceholder: { en: "Email", th: "อีเมล" },
    messageLabel: {
      en: "Type your question, suggestion, or feedback. Please provide as much detail as possible.",
      th: "พิมพ์คำถาม ข้อเสนอแนะ หรือความคิดเห็นของคุณ กรุณาเขียนรายละเอียดให้มากที่สุดเท่าที่จะทำได้",
    },
    messagePlaceholder: { en: "Your message here...", th: "พิมพ์ข้อความของคุณที่นี่..." },
    submit: { en: "Send", th: "ส่งข้อความ" },
    sending: { en: "Sending...", th: "กำลังส่ง..." },
    pailinAlt: { en: "Pailin", th: "ไพลิน" },
  },
  freePlanBenefits: {
    items: [
      {
        en: "Access to the 1st lesson of each level - 16 lessons total!",
        th: "เข้าถึงบทเรียนแรกของทุกระดับการเรียน รวมทั้งหมด 16 บทเรียน!",
      },
      {
        en: "Leave comments on free lessons and get feedback from us!",
        th: "สามารถแสดงความเห็นของคุณในบทเรียนฟรี และรับคำตอบกลับจากเรา!",
      },
      {
        en: "Partial access to our Resource pages, which include:",
        th: "เข้าถึงหน้าแหล่งเรียนรู้ของเราบางส่วน ประกอบไปด้วย:",
      },
      { en: "Grammar exercise bank", th: "คลังแบบฝึกหัดด้านไวยาการณ์" },
      {
        en: "Common mistakes made by Thai speakers",
        th: "ดูข้อผิดพลาดการใช้ภาษาที่คนไทยมักใช้ผิดบ่อยครั้ง",
      },
      { en: "Useful phrases & phrasal verbs", th: "เรียนรู้วลี และ phrasal verbs ที่เจ้าของภาษาใช้บ่อย" },
      { en: "American culture notes", th: "เกร็ดวัฒนธรรมอเมริกันน่ารู้" },
      {
        en: "Our topic library to supplement your English learning",
        th: "คลังหัวข้อเพื่อเสริมการเรียนรู้ภาษาอังกฤษของคุณ",
      },
    ],
  },
  home: {
    hero: {
      title: { en: "English learning for Thai speakers", th: "เรียนภาษาอังกฤษสำหรับคนไทย" },
      subtitle: {
        en: "Lessons based on audio conversations to teach useful, conversational English.",
        th: "บทเรียนผ่านทางบทสนทนาเสียง เพื่อฝึกการใช้ภาษาอังกฤษที่ใช้ได้จริงในชีวิตประจำวัน",
      },
      cta: { en: "SIGN UP FOR FREE", th: "สมัครเรียนฟรี" },
    },
    freeLessons: {
      headerTitle: { en: "Try a free lesson now!", th: "ลองเรียนบทเรียนฟรีตอนนี้เลย!" },
      headerSubtitle: { en: "No sign up needed.", th: "ไม่ต้องสมัครสมาชิก" },
      headerTitleFirst: { en: "Try a free", th: "ลองเรียนบทเรียนฟรี" },
      headerTitleSecond: { en: "lesson now!", th: "ตอนนี้เลย!" },
      header: { en: "Try a free lesson now! No sign up needed.", th: "ลองเรียนบทเรียนฟรีตอนนี้เลย! ไม่ต้องสมัครสมาชิก" },
      cards: [
        {
          level: { en: "BEGINNER", th: "BEGINNER" },
          title: { en: "Surfing at Venice Beach", th: "เล่นเซิร์ฟที่หาดเวนิส" },
          focusLabel: { en: "LESSON FOCUS", th: "เนื้อหาบทเรียน" },
          description: {
            en: "Habits and routines with present simple tense",
            th: "การพูดถึงนิสัยและกิจวัตรประจำวันด้วย present simple tense (กาลปัจจุบันธรรมดา)",
          },
        },
        {
          level: { en: "INTERMEDIATE", th: "INTERMEDIATE" },
          title: { en: "Look, there's a celebrity!", th: "ดูสิ มีคนดังด้วยนะ!" },
          focusLabel: { en: "LESSON FOCUS", th: "เนื้อหาบทเรียน" },
          description: {
            en: "How to use 'There is' and 'There Are'",
            th: "การใช้ There is และ There are (มี)",
          },
        },
        {
          level: { en: "ADVANCED", th: "ADVANCED" },
          title: { en: "At the baseball game", th: "ที่สนามแข่งเบสบอล" },
          focusLabel: { en: "LESSON FOCUS", th: "เนื้อหาบทเรียน" },
          description: {
            en: "Practice -ing and -ed adjectives",
            th: "ฝึกใช้คำคุณศัพท์ -ing และ -ed",
          },
        },
        {
          level: { en: "EXPERT", th: "EXPERT" },
          title: { en: "Spaghetti sauce everywhere!", th: "ซอสสปาเก็ตตี้เลอะเทอะไปหมด!" },
          focusLabel: { en: "LESSON FOCUS", th: "เนื้อหาบทเรียน" },
          description: {
            en: "How to use past perfect tense",
            th: "การใช้ past perfect tense (กาลต่อเนื่องอดีต)",
          },
        },
      ],
      comingSoon: { en: "COMING SOON!", th: "เร็วๆนี้!" },
      button: { en: "GO TO LESSON", th: "ไปที่บทเรียน" },
    },
    placement: {
      title: { en: "Not sure where to start?", th: "ยังไม่แน่ใจว่าจะเริ่มตรงไหน?" },
      cta: { en: "TAKE OUR FREE PLACEMENT TEST", th: "ทำแบบทดสอบวัดระดับฟรีของเรา" },
    },
    features: {
      items: [
        { title: { en: "200+ audio lessons", th: "บทเรียนเสียงกว่า 200 บท" } },
        { title: { en: "Content made by native English speakers", th: "เนื้อหาโดยเจ้าของภาษาอังกฤษ" } },
        { title: { en: "Useful, everyday English", th: "ภาษาอังกฤษที่ใช้ได้จริงในชีวิตประจำวัน" } },
      ],
    },
    method: {
      title: { en: "THE METHOD", th: "วิธีเรียนรู้" },
      body: {
        en: "Pailin Abroad offers English lessons based on audio conversations designed to teach natural, practical, and conversational English. Each lesson focuses on a grammar point or key concept, seamlessly integrated into real-world dialogue. The dialogues follow Pailin, a 21-year-old girl from Thailand, who will be studying abroad at UCLA while staying with a host family in Los Angeles. Through her journey navigating friendships, love, family, school, work, and life in a new country, you’ll gain rich insights into American culture, avoid common mistakes Thai learners often face, and most importantly, improve your English.",
        th: "Pailin Abroad นำเสนอบทเรียนภาษาอังกฤษจากบทสนทนาเสียงที่ออกแบบมาเพื่อสอนภาษาอังกฤษที่เป็นธรรมชาติ ใช้งานได้จริง และใช้ในชีวิตประจำวัน ทุกบทเรียนจะเน้นจุดไวยากรณ์หรือแนวคิดสำคัญที่ผสานอยู่ในบทสนทนาที่เกิดขึ้นจริง เนื้อเรื่องติดตามไพลิน วัย 21 ปีจากกรุงเทพฯ ที่เดินทางมาเรียนต่อที่ UCLA และพักกับโฮสต์แฟมิลี่ในลอสแอนเจลิส ผ่านการเดินทางของเธอทั้งมิตรภาพ ความรัก ครอบครัว โรงเรียน การทำงาน และการใช้ชีวิตในประเทศใหม่ คุณจะได้เข้าใจวัฒนธรรมอเมริกันอย่างลึกซึ้ง เลี่ยงข้อผิดพลาดที่ผู้เรียนชาวไทยมักเจอ และที่สำคัญที่สุดคือพัฒนาภาษาอังกฤษของคุณ",
      },
    },
    chooseUs: {
      title: { en: "Why choose Pailin Abroad?", th: "ทำไมถึงต้องเลือกเรียนกับ Pailin Abroad?" },
      reasons: [
        { text: { en: "Natural, everyday English", th: "ภาษาอังกฤษที่มีการใช้จริงในชีวิตประจำวัน" } },
        { text: { en: "Content by native English speakers", th: "เนื้อหาเขียนโดยเจ้าของภาษา" } },
        { text: { en: "All content translated to Thai", th: "เนื้อหาทุกบทแปลเป็นภาษาไทย" } },
        { text: { en: "Listen to real conversations", th: "ได้ฟังบทสนทนาจริงจากสถานการณ์จริง" } },
        { text: { en: "Learn common mistakes by Thais", th: "เรียนรู้ข้อผิดพลาดที่คนไทยมักใช้ผิด" } },
      ],
    },
    howItWorks: {
      title: { en: "How it works", th: "วิธีการเรียน" },
      steps: [
        {
          number: "1",
          header: { en: "Listen to the conversation", th: "ฟังบทสนทนา" },
          text: {
            en: "Move from Beginner to Expert level conversations that follow Pailin as she navigates life in a new country.",
            th: "เริ่มตั้งแต่ระดับ Beginner (มือใหม่) ไปจนถึง Expert (มือโปร) โดยเรียนผ่านตัวละคร ‘ไพลิน’ ที่เล่าเรื่องการใช้ชีวิตในประเทศใหม่",
          },
        },
        {
          number: "2",
          header: { en: "Dive into the lesson focus", th: "เจาะลึกเนื้อหาบทเรียน" },
          text: {
            en: "Learn the lesson's grammar topic or important word in the context of a real conversation, not just by memorizing rules.",
            th: "เรียนรู้ไวยาการณ์หรือคำศัพท์สำคัญในบทเรียนผ่านบทสนทนาจริง ไม่ใช่แต่การท่องจำกฎการใช้เพียงอย่างเดียว",
          },
        },
        {
          number: "3",
          header: { en: "Build your fluency", th: "พัฒนาความคล่องแคล่วในการใช้ภาษาของคุณ" },
          text: {
            en: "Solidify your learning with exercises, common mistakes, useful phrases, and American culture insights.",
            th: "เสริมการเรียนรู้ของคุณด้วยแบบฝึกหัด ข้อผิดพลาดที่พบบ่อย วลีที่ใช้บ่อย และเกร็ดน่ารู้ในวัฒนธรรมอเมริกัน",
          },
        },
      ],
    },
    signUpCTA: {
      titleParts: {
        beforeEm: { en: "Ready to access", th: "พร้อมเข้าถึง" },
        emphasis: { en: "all", th: "บทเรียนฟรีทั้งหมด" },
        afterEm: { en: "our free lessons?", th: "ของเราหรือยัง?" },
      },
      cta: { en: "SIGN UP FOR FREE", th: "สมัครสมาชิกฟรี" },
    },
    takeTheLeap: {
      title: { en: "Take the leap with Pailin and sign up today!", th: "ก้าวไปกับไพลินและสมัครวันนี้เลย!" },
      cta: { en: "SIGN UP FOR FREE", th: "สมัครสมาชิกฟรี" },
    },
    characters: {
      title: { en: "Meet the Characters", th: "ทำความรู้จักตัวละคร" },
      entries: [
        {
          name: { en: "Pailin", th: "ไพลิน" },
          description: {
            en: "Hi, I’m Pailin! I’m a 21-year-old girl from Bangkok. I’m studying abroad at UCLA and living with a host family in Los Angeles. I’m excited to explore the city, meet new friends, and experience everything LA has to offer. I love cooking Thai food, going to concerts, and geeking out at art museums. I know this is going to be an amazing adventure!",
            th: "ฉันชื่อไพลิน อายุ 21 ปีจากกรุงเทพฯ ฉันจะไปเรียนต่อที่ลอสแอนเจลิสเป็นเวลา 1 ปี ฉันเป็นคนสบาย ๆ และตื่นเต้นมากที่จะได้ลองประสบการณ์ใหม่ ๆ ฉันคิดว่าฉันจะเข้ากับที่นั่นได้ดีแน่นอน!",
          },
        },
        {
          name: { en: "Luke", th: "ลุค" },
          description: {
            en: "Meet Luke! He’s Pailin’s 22-year-old host brother. He was born and raised in Los Angeles and is also a student at UCLA. With his friendly personality, he’s the perfect guide to help Pailin navigate life in the US, and he quickly becomes one of Pailin’s closest friends. Luke is into basketball, hip-hop music, and late-night taco runs.",
            th: "ทำความรู้จักลุค! เขาเป็นพี่ชายโฮสต์ของไพลิน อายุ 22 ปี เขาเกิดและโตที่ลอสแอนเจลิส และเป็นนักศึกษาที่ UCLA ด้วย ด้วยบุคลิกที่เป็นมิตร เขาเป็นไกด์ที่ยอดเยี่ยมที่จะช่วยไพลินปรับตัวกับชีวิตในอเมริกา และไม่นานก็กลายเป็นเพื่อนสนิทคนหนึ่งของไพลิน ลุคชอบบาสเกตบอล ดนตรีฮิปฮอป และออกไปกินทาโก้ดึกๆ",
          },
        },
        {
          name: { en: "Chloe", th: "โคลอี้" },
          description: {
            en: "Meet Chloe! She’s a 23-year-old girl from Chiang Mai - half Thai, half French. Chloe and Pailin meet at their student orientation and quickly become best friends. Chloe loves to have a good time and always seems to have a funny story about her dating life in LA. She loves fashion and soccer, and she loves a good party!",
            th: "ฉันคือโคลอี้ เพื่อนใหม่ของไพลินที่ลอสแอนเจลิส พ่อของฉันเป็นคนไทย แม่เป็นชาวฝรั่งเศส แต่ฉันเติบโตที่ประเทศไทย ฉันเป็นคนร่าเริงและสนุกสนาน บางทีก็ซุ่มซ่ามนิดหน่อยและมีความกวน ๆ อยู่บ้าง",
          },
        },
        {
          name: { en: "Mark", th: "มาร์ค" },
          description: {
            en: "Meet Mark! He’s Pailin’s host dad. He’s a lawyer and makes sure Pailin is settling into her new life in LA. He enjoys skiing and playing pickleball, and he’s a great source of knowledge for Pailin to learn about American culture! He’s also a big history buff and loves game nights with his family, especially trivia nights.",
            th: "ผมคือมาร์ค คุณพ่อโฮสต์ของไพลิน ผมเป็นทนายที่ยุ่งมาก แต่ถ้าไม่ได้ทำงาน ผมชอบซ้อมวิ่งมาราธอนและอ่านนวนิยายไซไฟ",
          },
        },
        {
          name: { en: "Emily", th: "เอมิลี่" },
          description: {
            en: "Meet Emily! She’s Pailin’s 13-year-old host sister, just a freshman in high school. Emily is quirky and always getting herself into trouble. Pailin feels like a big sister to her, and she loves opening up to Pailin about her school and boy problems. She’s obsessed with K-Pop music, TikTok videos of Moo Deng, and doing cute nail designs.",
            th: "ฉันคือเอมิลี่ น้องสาวโฮสต์ของไพลิน ฉันเป็นเด็กวัย 13 ที่ช่างสงสัยและพูดเก่งมาก บางครั้งก็สร้างเรื่องวุ่นวาย แต่โดยรวมแล้วฉันน่ารักนะ (ฉันว่าอย่างนั้น)",
          },
        },
        {
          name: { en: "Sylvie", th: "ซิลวี่" },
          description: {
            en: "Meet Sylvie! She’s Pailin’s host mom. She’s originally from France, and she owns a wine business. She’s easygoing and super welcoming of Pailin, and often gives Pailin heartfelt advice about finding her place in a new country. When she’s not having a glass of red wine, she loves gardening, baking, and hosting dinner parties for her clients.",
            th: "ฉันคือซิลวี่ แม่โฮสต์ของไพลิน ฉันมาจากฝรั่งเศสและทำงานนำเข้าไวน์ ฉันชอบลองอาหารใหม่ ๆ ชอบอากาศอุ่น ๆ ที่ชายหาด และชอบใช้เวลากับครอบครัว",
          },
        },
      ],
    },
    reviews: {
      title: { en: "Reviews", th: "เสียงจากผู้ใช้" },
      items: [
        {
          name: { en: "BEER", th: "เบียร์" },
          location: { en: "Bangkok, Thailand", th: "กรุงเทพฯ ประเทศไทย" },
          text: {
            en: "I loved using Pailin Abroad – Pailin’s adventures made learning feel fun and engaging. The lessons were easy to follow and helped me improve my listening and comprehension skills in a natural way.",
            th: "ฉันชอบใช้ Pailin Abroad มาก การผจญภัยของไพลินทำให้การเรียนสนุกและน่าติดตาม บทเรียนเข้าใจง่ายและช่วยให้ฉันพัฒนาทักษะการฟังและการจับใจความได้อย่างเป็นธรรมชาติ",
          },
        },
        {
          name: { en: "SEEN", th: "ซีน" },
          location: { en: "Los Angeles, CA, USA", th: "ลอสแอนเจลิส แคลิฟอร์เนีย สหรัฐอเมริกา" },
          text: {
            en: "I loved using Pailin Abroad – Pailin’s adventures made learning feel fun and engaging. The lessons were easy to follow and helped me improve my listening and comprehension skills in a natural way.",
            th: "ฉันชอบใช้ Pailin Abroad มาก การผจญภัยของไพลินทำให้การเรียนสนุกและน่าติดตาม บทเรียนเข้าใจง่ายและช่วยให้ฉันพัฒนาทักษะการฟังและการจับใจความได้อย่างเป็นธรรมชาติ",
          },
        },
        {
          name: { en: "PRAEW", th: "แพรว" },
          location: { en: "Chiang Mai, Thailand", th: "เชียงใหม่ ประเทศไทย" },
          text: {
            en: "Pailin Abroad quickly helped me feel comfortable speaking with restaurant customers here in LA, and helped me improve my English enough that I’ve started making good friends out here.",
            th: "Pailin Abroad ช่วยให้ฉันคุยกับลูกค้าที่ร้านอาหารในลอสแอนเจลิสได้อย่างมั่นใจ และทำให้ฉันพัฒนาภาษาอังกฤษจนเริ่มมีเพื่อนดี ๆ ที่นี่",
          },
        },
      ],
    },
    faq: {
      title: { en: "Frequently Asked Questions", th: "คำถามที่พบบ่อย" },
      items: [
        {
          id: 1,
          question: {
            en: "How is Pailin Abroad different from other English-learning platforms?",
            th: "Pailin Abroad แตกต่างจากแพลตฟอร์มเรียนภาษาอังกฤษอื่นอย่างไร?",
          },
          answer: {
            en: "Pailin Abroad focuses on real-world conversational English through engaging storytelling. Unlike traditional platforms that rely on isolated grammar lessons, we follow Pailin's authentic journey in America, giving you context for every phrase and expression. Our content is created by native English speakers and fully translated to Thai, making complex concepts accessible while teaching you the natural flow of American English conversations.",
            th: "Pailin Abroad เน้นภาษาอังกฤษที่ใช้จริงผ่านการเล่าเรื่องที่สนุกสนาน ต่างจากแพลตฟอร์มทั่วไปที่สอนไวยากรณ์แยกส่วน เราติดตามการเดินทางจริงของไพลินที่อเมริกา ทำให้คุณเข้าใจบริบทของทุกวลีและสำนวน เนื้อหาของเราสร้างโดยเจ้าของภาษาและมีคำแปลภาษาไทยครบถ้วน จึงเข้าถึงเนื้อหาที่ซับซ้อนได้ง่าย พร้อมเรียนรู้จังหวะภาษาที่เจ้าของภาษาใช้จริง",
          },
        },
        {
          id: 2,
          question: {
            en: "Which skills does Pailin Abroad focus on?",
            th: "Pailin Abroad เน้นพัฒนาทักษะอะไรบ้าง?",
          },
          answer: {
            en: "We primarily focus on listening comprehension and conversational speaking skills. Through our audio-based lessons, you'll develop your ability to understand natural English conversations, improve your pronunciation, learn common phrases and expressions, and build confidence in real-world communication scenarios. Each lesson also includes cultural insights to help you navigate American social situations.",
            th: "เรามุ่งเน้นทักษะการฟังและการสนทนาเป็นหลัก ผ่านบทเรียนเสียงของเรา คุณจะพัฒนาความสามารถในการเข้าใจบทสนทนาภาษาอังกฤษที่เป็นธรรมชาติ ปรับปรุงการออกเสียง เรียนรู้วลีและสำนวนที่ใช้บ่อย และเพิ่มความมั่นใจในการสื่อสารจริง นอกจากนี้ทุกบทเรียนยังมีเกร็ดวัฒนธรรมช่วยให้คุณเข้าใจสังคมอเมริกันได้ดีขึ้น",
          },
        },
        {
          id: 3,
          question: {
            en: "Do you offer a free trial?",
            th: "มีทดลองใช้งานฟรีหรือไม่?",
          },
          answer: {
            en: "Yes! We offer a comprehensive library of free lessons that you can access immediately - no credit card required. Simply sign up with your email to start learning with Pailin right away. Our free content gives you a great taste of our teaching style and the quality of our lessons before you decide on a membership.",
            th: "มีแน่นอน! เรามีคลังบทเรียนฟรีที่คุณเข้าถึงได้ทันทีโดยไม่ต้องใช้บัตรเครดิต เพียงลงทะเบียนด้วยอีเมลก็เริ่มเรียนกับไพลินได้เลย เนื้อหาฟรีเหล่านี้จะทำให้คุณเห็นแนวการสอนและคุณภาพบทเรียนก่อนตัดสินใจสมัครสมาชิก",
          },
        },
        {
          id: 4,
          question: {
            en: "What are your membership options?",
            th: "แพ็กเกจสมาชิกมีอะไรบ้าง?",
          },
          answer: {
            en: "We offer 3 affordable membership options, which you can check out {{membershipLink}}. For the cost of one private English lesson, you can get a whole month of Pailin Abroad! If you're not ready for membership, you can sign up to access our library of free lessons! {{signupLink}} to sign up - no credit card needed!",
            th: "เรามีตัวเลือกสมาชิก 3 แบบในราคาย่อมเยา คุณสามารถดูรายละเอียดได้ที่{{membershipLink}} จ่ายเท่าค่าเรียนตัวต่อตัวหนึ่งครั้งก็ได้ใช้ Pailin Abroad ทั้งเดือน! หากยังไม่พร้อมเป็นสมาชิก คุณก็ลงทะเบียนเพื่อเข้าถึงคลังบทเรียนฟรีของเราได้เลย {{signupLink}}เพื่อลงทะเบียนโดยไม่ต้องใช้บัตรเครดิต!",
          },
          answerLinks: {
            membershipLink: {
              text: { en: "here", th: "ที่นี่" },
              to: "/membership",
            },
            signupLink: {
              text: { en: "Click here", th: "คลิกที่นี่" },
              to: "/signup",
            },
          },
        },
      ],
    },
  },
  footer: {
    sections: {
      resources: {
        title: { en: "RESOURCES", th: "แหล่งข้อมูล" },
        items: [
          { text: { en: "Lesson Library", th: "คลังบทเรียน" }, link: "/lessons" },
          { text: { en: "Free Lessons", th: "บทเรียนฟรี" }, link: "/free-lessons" },
          { text: { en: "Phrases & Phrasal Verbs", th: "วลีและ Phrasal Verbs" }, link: "/resources?section=phrases-verbs" },
          { text: { en: "Culture Notes", th: "เกร็ดวัฒนธรรม" }, link: "/resources?section=culture-notes" },
          { text: { en: "Common Mistakes", th: "ข้อผิดพลาดที่พบบ่อย" }, link: "/resources?section=common-mistakes" },
        ],
      },
      about: {
        title: { en: "ABOUT US", th: "เกี่ยวกับเรา" },
        items: [
          { text: { en: "The Method", th: "วิธีการสอน" }, link: "/about?section=method" },
          { text: { en: "Our Team", th: "ทีมของเรา" }, link: "/about?section=our-team" },
          { text: { en: "Membership", th: "สมาชิก" }, link: "/membership" },
        ],
      },
      help: {
        title: { en: "HELP CENTER", th: "ศูนย์ช่วยเหลือ" },
        items: [
          { text: { en: "Contact Us", th: "ติดต่อเรา" }, link: "/contact" },
          { text: { en: "Delete Account", th: "ลบบัญชีผู้ใช้" }, link: "/delete-account" },
          { text: { en: "Privacy Policy", th: "นโยบายความเป็นส่วนตัว" }, link: "/privacy" },
          { text: { en: "Terms & Conditions", th: "ข้อกำหนดและเงื่อนไข" }, link: "/terms" },
        ],
      },
    },
    followUsTitle: { en: "FOLLOW US", th: "ติดตามเรา" },
    copyright: {
      en: "Copyright © {year}, Pailin Abroad",
      th: "ลิขสิทธิ์ © {year} Pailin Abroad",
    },
  },
  legal: {
    privacyTitle: { en: "Privacy Policy", th: "นโยบายความเป็นส่วนตัว" },
    termsTitle: { en: "Terms & Conditions", th: "ข้อกำหนดและเงื่อนไข" },
    deleteAccountTitle: { en: "Delete Account", th: "ลบบัญชีผู้ใช้" },
    loading: { en: "Loading document...", th: "กำลังโหลดเอกสาร..." },
    missing: {
      en: "We could not load this document yet. Please check back soon.",
      th: "ยังไม่สามารถโหลดเอกสารนี้ได้ในตอนนี้ กรุณาลองใหม่ภายหลัง",
    },
  },
  lessonPage: {
    sectionFallbacks: {
      comprehension: { en: "Comprehension", th: "ความเข้าใจ" },
      transcript: { en: "Transcript", th: "สคริปต์บท" },
      practice: { en: "Practice", th: "แบบฝึกหัด" },
      phrasesVerbs: { en: "Phrases & Verbs", th: "วลีและคำกริยา" },
      apply: { en: "Apply", th: "การนำไปใช้" },
      extraTip: { en: "Extra Tips", th: "เคล็ดลับเพิ่มเติม" },
      commonMistake: { en: "Common Mistakes", th: "ข้อผิดพลาดที่พบบ่อย" },
      understand: { en: "Understand", th: "การทำความเข้าใจ" },
      cultureNote: { en: "Culture Note", th: "เกร็ดความรู้ทางวัฒนธรรม" },
    },
    locked: {
      previewTitle: { en: "This lesson is locked", th: "บทเรียนนี้ถูกล็อก" },
      previewBody: { en: "Sample content preview...", th: "ดูตัวอย่างเนื้อหาได้เล็กน้อย..." },
      overlayTitle: { en: "This Lesson is Locked", th: "บทเรียนนี้ถูกล็อก" },
      overlayBody: {
        en: "Unlock unlimited access to all lessons and features",
        th: "ปลดล็อกการเข้าถึงบทเรียนและฟีเจอร์ทั้งหมด",
      },
      ctaSignUp: { en: "SIGN UP FOR FREE", th: "สมัครสมาชิกฟรี" },
      ctaBecomeMember: { en: "BECOME A MEMBER", th: "สมัครเป็นสมาชิก" },
    },
    quiz: {
      checkAnswers: { en: "Check answers", th: "ตรวจสอบคำตอบ" },
    },
    practice: {
      empty: { en: "No practice exercises for this lesson.", th: "ยังไม่มีแบบฝึกหัดสำหรับบทเรียนนี้" },
    },
    backToTop: { en: "Back to Top", th: "กลับไปด้านบน" },
    selectSection: { en: "Select a section", th: "เลือกหัวข้อ" },
    placeholders: {
      applyResponse: { en: "Type your response here…", th: "พิมพ์คำตอบของคุณที่นี่…" },
      answer: { en: "Type your answer here", th: "พิมพ์คำตอบของคุณที่นี่…" },
    },
    loadingImageAlt: { en: "Loading lesson", th: "กำลังโหลดบทเรียน" },
    loadingErrorTitle: { en: "Something went wrong", th: "เกิดข้อผิดพลาด" },
    loadingErrorBody: {
      en: "We couldn't load this lesson. Please try refreshing the page.",
      th: "เราไม่สามารถโหลดบทเรียนนี้ได้ กรุณารีเฟรชหน้าเว็บแล้วลองอีกครั้ง",
    },
  },
  lessonToggle: {
    toThai: { en: "Translate to Thai", th: "แปลเป็นภาษาไทย" },
    toEnglish: { en: "Translate to English", th: "แปลเป็นภาษาอังกฤษ" },
    toThaiContent: { en: "Translate Content to Thai", th: "แปลเนื้อหาเป็นภาษาไทย" },
    toEnglishContent: { en: "Translate Content to English", th: "แปลเนื้อหาเป็นภาษาอังกฤษ" },
  },
  lessonNav: {
    lessonLabel: { en: "Lesson", th: "บทเรียน" },
    checkpointLabel: { en: "Checkpoint", th: "จุดตรวจสอบ" },
    markComplete: {
      en: "Mark Lesson as Finished",
      th: "ทำเครื่องหมายว่าบทเรียนเสร็จแล้ว",
    },
    markCompleteFallback: {
      en: "Mark Lesson as Finished",
      th: "ทำเครื่องหมายว่าบทเรียนเสร็จแล้ว",
    },
    completedAlt: { en: "Completed", th: "เสร็จแล้ว" },
    markCompleteAlt: { en: "Mark as complete", th: "ทำเครื่องหมายว่าเสร็จแล้ว" },
  },
  lessonDiscussion: {
    title: { en: "Join the Discussion", th: "เข้าร่วมการพูดคุย" },
    placeholder: {
      en: "Respond to our pinned comment or leave a question!",
      th: "ตอบคอมเมนต์ที่ปักหมุดไว้ หรือฝากคำถามของคุณ!",
    },
    submit: { en: "Submit", th: "ส่ง" },
    submitting: { en: "Submitting...", th: "กำลังส่ง..." },
    loginPrompt: {
      en: "You must have an account to leave a comment.",
      th: "คุณต้องมีบัญชีผู้ใช้ก่อนจึงจะแสดงความคิดเห็นได้",
    },
    comments: { en: "Comments", th: "ความคิดเห็น" },
    loading: { en: "Loading comments…", th: "กำลังโหลดความคิดเห็น…" },
    empty: {
      en: "Be the first to start the conversation.",
      th: "เป็นคนแรกที่เริ่มการสนทนาได้เลย",
    },
    pinnedAlt: { en: "Pinned comment", th: "ความคิดเห็นที่ปักหมุดไว้" },
    pin: { en: "Pin", th: "ปักหมุด" },
    unpin: { en: "Unpin", th: "ยกเลิกปักหมุด" },
    reply: { en: "Reply", th: "ตอบกลับ" },
    delete: { en: "Delete", th: "ลบ" },
    deleteConfirm: {
      en: "Delete this comment?",
      th: "ลบความคิดเห็นนี้หรือไม่?",
    },
  },
};

export function t(path, ui = "en") {
  // path like "nav.home" or "uiLabel"
  const parts = path.split(".");
  let node = copy;
  for (const p of parts) node = node?.[p];
  if (!node) return "";
  if (typeof node === "string") return node; // already a leaf
  return node[ui] ?? node.en ?? "";
}

export function pick(node, ui = "en") {
  if (!node) return "";
  if (typeof node === "string") return node;
  return node[ui] ?? node.en ?? "";
}
